<template>
  <nav class="about-hailin-page">
    <div class="vertical-nav">
      <div
          class="nav-item"
          :class="{ active: activeIndex === 0 }"
          @click="scrollToElement('A', 0)"
      >
        <div class="nav-circle"></div>
      </div>
      <div
          class="nav-item"
          :class="{ active: activeIndex === 1 }"
          @click="scrollToElement('container1', 1)"
      >
        <div class="nav-circle"></div>
      </div>
      <div
          class="nav-item"
          :class="{ active: activeIndex === 2 }"
          @click="scrollToElement('jingzheng', 2)"
      >
        <div class="nav-circle"></div>
      </div>
      <div
          class="nav-item"
          :class="{ active: activeIndex === 3 }"
          @click="scrollToElement('ziyuanyoushi', 3)"
      >
        <div class="nav-circle"></div>
      </div>
      <div
          class="nav-item"
          :class="{ active: activeIndex === 4 }"
          @click="scrollToElement('container6-new', 4)"
      >
        <div class="nav-circle"></div>
      </div>
      <div
          class="nav-item"
          :class="{ active: activeIndex === 5 }"
          @click="scrollToElement('qudaoyoushi', 5)"
      >
        <div class="nav-circle"></div>
      </div>
      <div
          class="nav-item"
          :class="{ active: activeIndex === 6 }"
          @click="scrollToElement('chanpingyoushi', 6)"
      >
        <div class="nav-circle"></div>
      </div>
      <div
          class="nav-item"
          style="display: none;"
          :class="{ active: activeIndex === 7 }"
          @click="scrollToElement('container9', 7)"
      >
        <div class="nav-circle"></div>
      </div>
      <div
        class="nav-item-H"
        :class="{ active: activeIndex === 8 }"
        @click="scrollToElement('B', 8)"
    >
      <div class="nav-circle"></div>
    </div>
    </div>
    <div id="A" class="A">
      <caidan class="CaiDan"></caidan>
      <div class="CaiDanBottom"></div>
      <div class="banner-container">
        <img class="imgAbout" src="@/assets/about/1111.jpg">
      </div>
      <breadcrumb class="breadcrumb"></breadcrumb>

    </div>
    <div id="container1" class="container-1" ref="container1">
      <div class="container1">
        <!-- 添加背景容器 -->
        <div class="content-background" ref="content-background"></div>

        <img src="../../assets/about/aboutA.jpg" class="image-about" alt="公司大楼">

        <div class="box" ref="box">
          <div class="content" ref="content">
            <h1>{{ coporate[0].corporateName }}</h1>
            <p>{{ coporate[0].aboutP01 }}</p>
            <p>{{ coporate[0].aboutP02 }}</p>
          </div>
        </div>
      </div>
      <!--      <div class="container2">-->
      <!--        <div class="badges">-->
      <!--          <div class="badge" v-for="item in aboutcoporate" :key="item.about">-->
      <!--            {{ item.about }}-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
      <!--      <div class="stats-box">-->
      <!--        <div class="stats" >-->
      <!--          <div class="stat" v-for="(item,index) in stat" :key="item.IdA">-->
      <!--            <div class="stat-box">-->
      <!--              <div class="stat-icon"><img  :src="item.path" alt="Money Icon" /></div>-->
      <!--              <div class="stat-value-right">-->
      <!--                <span class="stat-value">{{ item.currentNum }}</span>-->
      <!--                <span class="stat-value-el">{{item.el}}</span>-->
      <!--                <div class="stat-about">{{item.about}}</div>-->
      <!--              </div>-->
      <!--            </div>-->
      <!--          </div>-->

      <!--        </div>-->
      <!--      </div>-->

    </div>
    <div id="jingzheng" class="jingzheng">
      <div class="container2">
        <div class="badges">
          <div class="badge" v-for="item in aboutcoporate" :key="item.about">
            {{ item.about }}
          </div>
        </div>
      </div>
      <div class="stats-box">
        <div class="stats" >
          <div class="stat" v-for="(item,index) in stat" :key="item.IdA">
            <div class="stat-box">
              <div class="stat-icon"><img  :src="item.path" alt="Money Icon" /></div>
              <div class="stat-value-right">
                <span class="stat-value">{{ item.currentNum }}</span>
                <span class="stat-value-el">{{item.el}}</span>
                <div class="stat-about">{{item.about}}</div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="title02">
    <h2>{{compete[0].title}}</h2>
      </div>

  <div class="jingzheng-content">
    <div class="jingzheng-description">
<!--      <p class="jingzheng-text">{{compete[0].process1}}{{compete[0].process2}}</p>-->
      <div class="jingzheng-text"><p>{{compete[0].process1}}</p><p style="color:#595757">{{compete[0].process2}}</p></div>
<!--      <p class="jingzheng-text">{{compete[0].process3}}{{compete[0].process4}}</p>-->
      <div class="jingzheng-text"><p>{{compete[0].process3}}</p><p style="color:#595757">{{compete[0].process4}}</p></div>
      <p class="jingzheng-text">{{compete[0].process5}}</p>
    </div>
    <div class="jingzheng-AYa" >
      <p class="jingzheng-subtext">{{compete[0].paragraph1}}</p>
      <p class="jingzheng-subtext">{{compete[0].paragraph2}}</p>
    </div>

    <div class="decorative-line"></div>
        </div>
      </div>
    <div id="ziyuanyoushi" class="ziyuanyoushi">
  <div class="title02">
    <h2>{{resource[0].title}}</h2>
      </div>
  <div class="ziyuanyoushi-content">
    <div class="ziyuanyoushi-text">
      <p class="main-text">{{resource[0].description1}}</p>
      <p class="main-text">{{resource[0].description2}}</p>
      <p class="main-text"><span>{{resource[0].description3}}</span> <span style="color: #00a0fa">{{resource[0].description4}}</span><span>{{resource[0].description5}}</span></p>
      <p class="main-text">{{resource[0].description6}}</p>
      <p class="main-text">{{resource[0].description7}}</p>
      <div class="divider"></div>
    </div>

    <div class="key-progress">
      <h3>关键进展</h3>
      <div class="progress-items">
        <div class="progress-item" v-for="(item ,index) in resourceDevelop" :key=" item.IdB">
          <div class="dot"></div>
          <p>{{item.description}}</p>
        </div>
<!--        <div class="progress-item">-->
<!--          <div class="dot"></div>-->
<!--          <p>2014年4月，与伊品集团建立战略合作</p>-->
<!--      </div>-->
<!--        <div class="progress-item">-->
<!--          <div class="dot"></div>-->
<!--          <p>2021年7月，与梅花集团合资成立通辽海邻</p>-->
<!--          </div>-->
<!--        <div class="progress-item">-->
<!--          <div class="dot"></div>-->
<!--          <p>2024年1月，与阜丰集团合资成立呼伦海邻</p>-->
<!--        </div>-->
        </div>
        </div>
      </div></div>
    <div id="container6-new" class="container6-new">

  <div class="advance-new">
    <div class="kong"></div>
    <div class="title02" style="filter: brightness(0) saturate(100%) invert(57%) sepia(4%) saturate(263%) hue-rotate(175deg); z-index: 0; position: relative;"></div>
    <div class="title03">
      <h2 >{{advancetitle[0].title}}</h2>
    </div>
    <div class="bottom-new">
      <img  src="../../assets/about/rearch-about@2x.png" >
    </div>
    <div class="result-word-new">
      <div class="result-title">
        <h1><span>{{advancetitle[0].about1}}</span><span style="color: #00a0fa">{{advancetitle[0].about2}}</span></h1>
        <h1>{{advancetitle[0].about3}}</h1>
        <h1>{{advancetitle[0].about4}}</h1>
      </div>
      <div class="result-description">
        <p>{{advancetitle[0].description}}</p>
      </div>
    </div>
    <div class="result-card-new">
      <div
          class="card-item"
          v-for="(item, index) in resultCardList"
          :class="item.cardClass"
      >
        <div class="card-number" :class="item.numberClass">
          <span>{{ item.currentNumber }}</span>
          <span
              class="card-unit"
              v-if="item.unit"
              :style="item.unitStyle || null"
          >
        {{ item.unit }}
      </span>
        </div>
        <div class="card-text" :class="item.textClass">{{ item.text }}</div>
      </div>
    </div>


  </div>
</div>
    <div id="qudaoyoushi" class="qudaoyoushi">
  <div class="title02">
    <h2>{{channel[0].title}}</h2>
          </div>
  <div class="qudaoyoushi-content">
    <div class="qudaoyoushi-text">
      <p class="channel-text">{{channel[0].cover}}</p>
      <p class="channel-text" style="color: #00a0fa">{{channel[0].Channel}}</p>
      <p class="channel-item" v-html="channel[0].description"></p>
<!--      <div class="channel-key">-->
<!--        <h3 style="color: #595757 ;font-weight: normal;">{{channel[0].keyChannel}}</h3>-->
        <!--        <div class="channel-items" v-for="(item, index) in channelDevelop" :key="item.Id">-->
<!--          <div class="channel-item">-->
<!--            <div class="dot"></div>-->
<!--            <p style="color: #595757">{{item.description}}</p>-->
<!--          </div>-->
<!--      </div>-->
<!--      </div>-->
            </div>
    <div class="channel-partners">
      <h3 class="partners-title">部分合作伙伴</h3>
      <img src="../../assets/about/friends/friends.png" alt="合作伙伴" class="partners-image">
          </div>
        </div>
    </div>
    <div id="chanpingyoushi" class="chanpingyoushi">
  <div class="title02">
    <h2>{{qualityTitle}}</h2>
  </div>
  <div class="chanpingyoushi-content">
    <div class="chanpingyoush-shangbufen">
      <div class="chanpingyoushi-box">
        <div class="chanpingyoushi-text1">{{qualityAbout}}</div>
        <div class="chanpingyoushi-text2">{{qualityDescription}}</div>
      </div>
    </div>
    <div class="chanpingyoushi-xiabufen" >
      <div class="chanpingyoushi-item" v-for="(item, index) in quality" key="item.Id">
        <div class="item-title-box">
          <div class="item-title">{{item.title}}</div>
          <div class="item-description">{{item.description}}</div>
        </div>
      </div>
<!--      <div class="chanpingyoushi-item">-->
<!--        <div class="item-title-box">-->
<!--          <div class="item-title">原 料</div>-->
<!--          <div class="item-description">以地域优势为基础，利用玉米深加工企业的各类副产物/固废为主要原料。</div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="chanpingyoushi-item">-->
<!--        <div class="item-title-box">-->
<!--          <div class="item-title">预 处 理</div>-->
<!--          <div class="item-description">抑制原料变质，维持原有营养水平，实现充足的原料接收和存储能力。</div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="chanpingyoushi-item">-->
<!--        <div class="item-title-box">-->
<!--          <div class="item-title">菌 种</div>-->
<!--          <div class="item-description">通过利用高活性复合菌剂高效降解饲料原料中的抗营养因子。</div>-->
<!--        </div>-->
<!--      </div>-->
<!--        <div class="chanpingyoushi-item">-->
<!--        <div class="item-title-box">-->
<!--          <div class="item-title">工 艺</div>-->
<!--          <div class="item-description">通过资源保鲜工艺、复合菌固态发酵工艺、低温烘干工艺提升营养价值。</div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="chanpingyoushi-item">-->
<!--        <div class="item-title-box">-->
<!--          <div class="item-title">质 控</div>-->
<!--          <div class="item-description">公司通过ISO9001质量管理体系认证，并且严格按照标准体系运行。</div>-->
<!--        </div>-->
<!--      </div>-->
    </div>
  </div>
</div>
    <div id="container9" class="container9" style="display:none;">
      <!-- 添加日期显示 -->
      <div class="date-display">
        <span class="date-number">{{ currentMonth }}</span>
        <span class="date-separator">/</span>
        <span class="total-days">{{ currentDay }}</span>
      </div>
      <!-- 背景图切换区域 -->
      <div class="bottomBackground" v-for="(item, index) in bottomBackground" :key="item.IdC">
        <div class="aboutBackground" v-if="index === currentImageIndex">
          <img  :src="item.src" alt="Background Image" class="background-image">
          <div class="bottomDescription">
            <p>{{ item.description1 }}<br>{{ item.description2 }}</p>
          </div>
        </div>
      </div>

      <!-- 控制按钮 -->
<!--      <div class="controlNext">-->
<!--        <img  class="last" src="@/assets/about/next@2x - 副本 .png" @click="lastImage">-->
<!--        <img  class="next" src="@/assets/about/next@2x.png" @click="nextImage">-->
<!--      </div>-->
   </div>
    <div id="B" class="B"></div>
    <!-- 置顶按钮 -->
    <button class="back-to-top" @click="scrollToTop">↑</button>


  </nav>
</template>

<script>
import Caidan from "@/components/caidan.vue";
import Breadcrumb from "@/components/breadcrumb.vue";

export default {
  name: "About",
  components: {Breadcrumb, Caidan},

  data() {
    return {
      // 添加这些变量

      scrollDirection: null,
      lastDirectionChange: 0,
      isScrolling: false, // 防止滚动冲突
      scrollDeltaAccumulator: 0,    // 累积 deltaY
      lastScrollTime: 0,            // 上次触发时间戳
      scrollCooldown: 600,          // 冷却时间 ms
      scrollThreshold: 50,          // 阈值 px

      scrollTopCounter: 0, // 新增，记录在container1向上滚动的次数
      activeIndex: 0, // 默认高亮第一个状态点
      showDataItems: [], // 用于控制每个data-item的显示状态
      designWidth: 1920,
      designHeight: 1080,
      showSearch: false,
      searchQuery: "",
      showMobileMenu: false,
      windowWidth: window.innerWidth,
      screenWidth: window.innerWidth,
      screenHeight: window.innerHeight,  // 添加屏幕高度
      coporate:[
        {
          corporateName: '内蒙古海邻科技发展有限公司',
          corporatSupplier: '新型饲用蛋白供应商',
          aboutP01: '内蒙古海邻科技发展有限公司是中国领先的新型饲用蛋白供应商、国家高新技术企业、"专精特新"中小企业。公司注册资本6506.0406万元，员工近300人。公司自2014年创立以来，持续深耕"新型饲用蛋白"领域，与中国科学院天津工业生物技术研究所、中国农业科学院北京畜牧兽医研究所、内蒙古农业大学、内蒙古民族大学等科研院所、高校紧密合作，致力于为养殖业健康可持续发展赋能。',
          aboutP02: '目前，海邻旗下拥有通辽、赤峰、大庆、龙江、呼伦贝尔等五大生产基地，年产能可达到60万吨。公司"统一管理、属地生产"的多基地生产模式，有利于节约运输、采购、销售和技术服务等成本，快速复制实现新型饲用蛋白规模化生产，促进科技成果转化，赋能下游养殖业提质增效。',
        }
      ],
      aboutcoporate:[
          {about:'国家高新技术企业'},
          {about:'专精特新中小企业'},
          {about:'自治区级农牧业产业化重点龙头企业'},
          {about:'国家绿色工厂'},
          {about:'自治区级企业技术中心'},
          {about:'新型饲用蛋白产业化应用示范基地'},
          {about:'自治区级企业研究开发中心'},
      ],
      foregroundtitle:'新型饲用蛋白市场前景广阔',
      fdescription:'新型饲用蛋白是指通过发酵、生物合成、微生物工程、酶工程等<br>' +
                   '现代生物技术生产制造出来的<br>' +
                   '用于动物饲料的蛋白质来源，旨在替代传统饲用蛋白，为饲料生产提供更多选择<br>' +
                   '创造一个更绿色、环保的动物饲料生态系统推动养殖业可持续发展',
      stat:[
        { IdA: 1, num: 83, el: '项', about: '国家专利', path: require('@/assets/about/About-icon-01@2x.png'), currentNum: 0 },
        { IdA: 2, num: 5, el: '个', about: '产业基地', path: require('@/assets/about/About-icon-02@2x.png'), currentNum: 0 },
        { IdA: 3, num: 60, el: '万吨', about: '年产能', path: require('@/assets/about/产能.png'), currentNum: 0 },
      ],
      resultCardList: [
        {
          number: 14,
          unit: '项',
          text: '发明专利',
          numberClass: 'blue-text',
          textClass: '',
          cardClass: '',
          currentNumber: 0,
        },
        {
          number: 69,
          unit: '项',
          text: '实用新型专利',
          numberClass: 'blue-text',
          textClass: '',
          cardClass: '',
          currentNumber: 0,
        },
        {
          number: 16800,
          unit: '㎡',
          text: '中试基地',
          numberClass: 'white-text',
          textClass: 'white-text',
          cardClass: 'blue-bg',
          unitStyle: {
            marginLeft: '5px',
            fontSize: '18px',
            fontFamily: 'Source Han Sans CN',
            color: '#fff',
            lineHeight: '2.389',
            textAlign: 'left'
          },
          currentNumber: 0,
        },
        {
          number: 5000,
          unit: '万',
          text: '累计研发投入',
          numberClass: 'white-text',
          textClass: 'white-text',
          cardClass: 'blue-bg',
          unitStyle: {
            marginLeft: '5px',
            fontSize: '18px',
            fontFamily: 'Source Han Sans CN',
            color: '#fff',
            lineHeight: '2.389',
            textAlign: 'left'
          },
          currentNumber: 0,
        }
      ],
      foreground:[
          {
            Id:1,
            title:'微生物蛋白',
            en:'MICROBIAL PROTEIN',
            description:'微生物蛋白是指通过酵母、细菌、丝状真菌等微生物发酵产生的蛋白质。',
            example:null,
            src: require('../../assets/about/microbial-protein.png'),
            width:213*0.6,
            height:170*0.6,
            margin:1,
            X:17,
            Y:63,
            shouJiX:70,
            shouJiY:30,
            cardWidth:95,
            cardHeight:120,
            cardMinHeight:130,
            },
          {
            Id:2,
            title:'基因工程蛋白',
            en:'GENETICALLY ENGINEERED PROTEIN',
            description:'通过基因工程技术来改造植物或微生物，使其生产出更多的蛋白质或优化蛋白质的营养成分。',
            example:'例如，基于酵母菌基因编辑的蛋白质、基于杂交水稻转录组的蛋白质等，都是基因工程技术在饲用蛋白领域的具体应用。',
            src: require('../../assets/about/genetically-engineered-protein.png'),
            width:160*0.6,
            height:227*0.6,
            margin:10,
            X:52,
            Y:52,
            shouJiX:70,
            shouJiY:25,
            cardWidth:95,
            cardHeight:150,
            cardMinHeight:220,
            },
          {
            Id:3,
            title:'藻类蛋白',
            en:'ALGAE PROTEIN',
            description:'通过发酵或光合作用，藻类能够有效地从环境中吸收营养物质并转化为蛋白质。',
            example:null,
            src:require('../../assets/about/algae-protein.png'),
            width:164*0.6,
            height:225*0.6,
            margin:10,
            X:80,
            Y:55,
            shouJiX:70,
            shouJiY:20,
            cardWidth:95,
            cardHeight:120,
            cardMinHeight:130,
           },
      ],

      Tactics:[
        {Id:'1',title:'— 国家战略性新兴产业 —',description1:'7.0 节能环保产业',description2:'7.3 资源循环利用产业',description3:'7.3.6 农林废弃物资源化利用',description4:null,},
        {Id:'2',title:'— 国家战略性新兴产业 —',description1:'4.0 生物产业',description2:'4.3生物农业及相关产业',description3:'4.3.3生物肥料制造',description4: '4.3.4 生物饲料制造',},
      ],
      tacticstitle:'横跨两大<br>国家战略性<br>新兴产业',
      tacticslefttitle:'为粮食产业处废增收',
      //x1+x2=50对称
      tacticsleft:[
        {Id:'1',title:'食用玉米',description:'食品边角料、碎屑',x:12,y:-65,},
        {Id:'2',title:'玉米作物加工副产品',description:'青储、玉米芯、秸秆等',x:34,y:-38,},
        {Id:'3',title:'玉米淀粉副产品',description:'糖渣、氨基酸、酶制剂等',x:42,y:-5,},
        {Id:'4',title:'玉米深加工副产品',description:'玉米胚芽、玉米蛋白粉、膨化玉米等',x:38,y:30,},
        {Id:'5',title:'玉米酒精加工',description:'DDGS、DDG、DDS等',x:18,y:70,},
      ],
      tacticsrighttitle:'为农牧产业降本增效',
      tacticsright:[
        {Id:'1',description1:'玉米精加工饲料',description2:'饲料原料',description3:null,x:38,y:-65,},
        {Id:'2',description1:'裹包发酵玉米、发酵玉米',description2:'保鲜玉米、发酵玉米芯',description3: null,x:16,y:-38,},
        {Id:'3',description1:'膳食纤维饲料、碎玉米饲料原料',description2:'高能量饲料、蛋白饲料',description3:'功能新饲料添加剂、菌丝体蛋白饲料',x:10,y:-5,},
        {Id:'4',description1:'生物饲料、喷浆纤维',description2:null,description3: null,x:12,y:30,},
        {Id:'5',description1:'生物饲料、玉米酶解蛋白、生物肥料',description2:null,description3:null,x:32,y:70,},
      ],

      HighLighttitle:'行业亮点',
      HighLight:[
        {
          Id: '01',
          title:'公司下游饲料市场空间广阔',
          description1:'根据国家统计局数据，我国饲料产量在过去10年呈上升趋势，2021年-2023年均突破3亿吨大关。',
          description2:'2023年全国工业饲料总产值14018.3亿元，比上年增长6.5%；全国工业饲料总产量32162.7万吨，比上年增长6.6%。',
        },
        {
          Id:'02',
          title: '豆粕减量替代，减抗限抗利好新型饲用蛋白市场',
          description1: '2021年，农业农村部全面推行饲料中豆粕减量替代，希望通过饲料原料的多元化来部分替代用量较大的豆粕。',
          description2: '同时，农业农村部近年来多次发文，对兽用抗菌药和兽用促生长类药物分别提出减量和禁用的要求，积极应用替代产品，利好新型饲用蛋白市场。',
        },
        {
          Id:'03',
          title: '上游服务大型粮食企业，下游销售优质客户',
          description1: '公司当前深耕粮食产业链副产物/固废原料，与国内多家大型粮食企业配套，包括阜丰集团、梅花集团、伊品集团、中粮集团、象屿集团等。',
          description2: '下游客户主要以大型饲料企业及自拌料养殖企业为主，包括正大、新希望六和、禾丰、益客、大北农等优质集团公司。',
        },
        {
          Id:'04',
          title: '多家大型玉米深加工企业预期扩张，公司产能加快布局',
          description1: '从上游供应端看，梅花生物、伊品生物、阜丰生物等粮食深加工企业均有产能扩张计划。因此未来公司上游原材料供给充足。',
          description2: '从公司产能端看，近年来公司产能逐步扩张，目前公司"10万吨产假丝酵母蛋白"项目正在建设，呼伦贝尔项目已正式成立，全部投产后总产能可达53万吨。',
        }
      ],

      compete:[
        {
          advance:'5大竞争优势',
          title:'海邻核心竞争力',
          about:'新型饲用蛋白供应商',
          process1:'从粮食产业链副产物',
          process2:'"资源化利用"',
          process3:'到新型饲用蛋白',
          process4:'"产业化应用"',
          process5:'真正打通上下游市场',
          paragraph1:'海邻在发展过程中积累的资源优势、技术优势、市场优势、产品优势',
          paragraph2:'为企业发展提供了强大的助推力和驱动力',
        }
      ],
      advance:[
        {Id:'1',dot:'技术优势',x:150,y:555,height:100},
        {Id:'2',dot:'渠道优势',x:287.5,y:513,height:141},
        {Id:'3',dot:'运营优势',x:425,y:443,height:212},
        {Id:'4',dot:'成本优势',x:562.5,y:339,height:315},
        {Id:'5',dot:'质量优势',x:700,y:195,height:460},
      ],
      advancetitle:[
        {
          title:'技术优势',
          about1:'海邻牵头创建',
          about2:'"新型饲用蛋白技术创新中心"',
          about3:'是国内新型饲用蛋白技术高地',
          about4:'为玉米产业副产物资源化利用提供战略引领作用',
          description:'2024年，海邻联合中国科学院天津工业生物技术研究所、中国农业科学院北京畜牧兽医研究所、内蒙古农业大学等创新联合体单位，共同创建国内首家新型饲用蛋白技术创新中心，立足玉米产业链深入开展资源评估、生物技术、工艺设备、蛋白应用等研究，以科技创新推动产业创新，助力国家粮食安全和畜牧业提质增效。',
        }
      ],
      results:[
        {Id:'1',num:14,el:'项',name:'发明专利',numcolor:'#00a0fa',fcolor:'black',bcolor:'white', elsize:10, linecolor:'grey',x:6000,y:20,CbColor:'#F5F5F5',sjX:100,sjY:100,mX:100,mY:100,pcX:100,pcY:100},
        {Id:'2',num:69,el:'项',name:'实用新型专利',numcolor:'#00a0fa',fcolor:'black',bcolor:'white', elsize:10,linecolor:'rgba(0, 0, 0, 0)',x:8,y:1,CbColor:'#F5F5F5',sjX:100,sjY:100,mX:100,mY:100,pcX:100,pcY:100},
        {Id:'3',num:16800,el:'m²',name:'中试基地',numcolor:'white',fcolor:'white',bcolor:'#00a0fa', elsize:10,linecolor:'white',x:6000,y:20,CbColor:'#00a0fa',sjX:100,sjY:100,mX:100,mY:100,pcX:100,pcY:100},
        {Id:'4',num:4000,el:'万',name:'累计研发投入',numcolor:'white',fcolor:'white',bcolor:'#00a0fa', elsize:10,linecolor:'rgba(0, 0, 0, 0)',x:8,y:1,CbColor:'#00a0fa',sjX:100,sjY:100,mX:100,mY:100,pcX:100,pcY:100},
      ],
      correlation: [
        { Id: 1, src: require('@/assets/about/rearch-about@2x.png') ,top:50,right:80,},
      ],
      resource:[
        {
          title:'资源优势',
          description1:'围绕中国东北黄金玉米带布局',
          description2:'充分利用玉米深加工企业各类副产物',
          description3:'采取 ',
          description4:' "统一管理、属地生产" ',
          description5:' 的经营模式',
          description6:'节约原料采购、运输、能源消耗等成本',
          description7:'提高经营效率和盈利能力',
        }
      ],
      resourceKey:'关键进展',
      resourceDevelop:[
        {IdB:1,description:'2014年4月，与伊品集团建立战略合作'},
        {IdB:2,description: '2021年7月，与梅花集团合资成立通辽海邻',},
        {IdB:3,description: '2024年1月，与阜丰集团合资成立呼伦海邻',},
      ],
      channel:[
        {
          title:'市场优势',
          cover:'2022年开始，海邻构建',
          Channel:'"事业部+产品线+业务部" 营销体系',
          description: '与正大、禾丰、新希望、海大、大北农、牧原、现代牧业等50余家行业知名品牌<br>' +
              '建立长期紧密合作<br>' +
              '销售网络覆盖20余个省份',
          keyChannel:'自建渠道',
          friends:'部分合作伙伴',
        }
      ],
      channelDevelop:[
        {
          Id:'1',description:'2022年开始，构建 "事业部+产品线+业务部" 营销体系'
        },
        {
          Id:'2',description: '2021年7月，构建 "牛保富" 综合服务平台'
        }
      ],
      qualityTitle:'产品优势',
      qualityAbout:'原料 + 预处理 + 菌种 + 工艺 + 质控',
      qualityDescription:'在产品生产过程中，公司通过"原料+预处理+菌种+工艺+质控"多重优势，保证产品品质。',
      quality:[
        {Id:1,title:'原 料',description:'以地域优势为基础，利用玉米深加工企业的各类副产物/固废为主要原料。',x:2,y:-5,X:18,XX:85},
        {Id:2,title:'预 处 理',description:'抑制原料变质，维持原有营养水平，实现充足的原料接收和存储能力。',x:22,y:17,X:41,XX:108},
        {Id:3,title:'菌 种',description:'通过利用高活性复合菌剂高效降解饲料原料中的抗营养因子。',x:42,y:-5,X:64,XX:132},
        {Id:4,title:'工 艺',description:'通过资源保鲜工艺、复合菌固态发酵工艺、低温烘干工艺提升营养价值。',x:63.5,y:17,X:87,XX:163},
        // {Id:5,title:'质 控',description:'公司通过ISO9001质量管理体系认证，并且严格按照标准体系运行。',x:82,y:-5,X:106,XX:156},
      ],
      currentImageIndex: 0, // 当前显示的图片索引
      bottomBackground: [
        {
          IdC: 1,
          src: require('@/assets/home/微信图片_20250328133642.jpg'),
          description1: '成为中国领先的',
          description2: '新型饲用蛋白供应商'
        },

      ],
      currentDay: '01',
      currentMonth: '01',
      isMobile: false,
      animationStarted: false,
      statAnimationStarted: false,
      resultAnimationStarted: false
    };

  },
  methods: {
    // updateScreenSize() {
    //   this.screenWidth = window.innerWidth;
    //   this.screenHeight = window.innerHeight;  // 更新屏幕高度
    // },

    setupIntersectionObservers() {
      // 存储每个容器的动画状态
      this.containerAnimationStates = {
        'A': false,
        'container1':false,
        'jingzheng': false,
        'ziyuanyoushi': false,
        'container6-new': false,
        'qudaoyoushi': false,
        'chanpingyoushi': false,
        'container9': false,
        'B': false,
      };

      // 监听滚动事件
      window.addEventListener('scroll', this.handleScrollAnimation);
      // 初始化时调用一次
      this.handleScrollAnimation();
    },
    handleScrollAnimation() {
      const containers = ['A', 'container1','jingzheng', 'ziyuanyoushi', 'container6-new', 'qudaoyoushi', 'chanpingyoushi','container9','B'];
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const triggerPoint = windowHeight * 0.01; // 触发点设置为视口高度的30%

      containers.forEach(containerId => {
        const container = document.getElementById(containerId);
        if (container) {
          const containerTop = container.offsetTop;
          const containerBottom = containerTop + container.offsetHeight;

          // 检查容器是否在视口中
          const isInViewport = scrollPosition + triggerPoint >= containerTop &&
              scrollPosition <= containerBottom;

          // 如果容器在视口中且之前未触发动画，则触发动画
          if (isInViewport && !this.containerAnimationStates[containerId]) {
            this.resetContainerAnimation(containerId);
            this.containerAnimationStates[containerId] = true;
          }
          // 如果容器不在视口中，重置动画状态
          else if (!isInViewport) {
            this.containerAnimationStates[containerId] = false;
          }
        }
      });
    },
    resetContainerAnimation(containerId) {
      if (window.innerWidth < 768) return;
      // if (window.innerWidth < 768) return; // 小屏幕不执行
      const container = document.getElementById(containerId);
      if (!container) return;

      // 检查是否已经执行过动画（sessionStorage 在刷新后会清空）
      const hasAnimatedKey = `hasAnimated-${containerId}`;
      if (sessionStorage.getItem(hasAnimatedKey)) {
        return; // 已经执行过动画，跳过
      }

      switch (containerId) {
        // case 'container1':
        //   const imageAbout = container.querySelector('.image-about');
        //   if (imageAbout) {
        //     imageAbout.style.opacity = '0';
        //     imageAbout.style.transform = 'translateX(-25%)';
        //     imageAbout.style.animation = 'none';
        //     void imageAbout.offsetWidth;
        //
        //     const imageKeyframes = [
        //       { opacity: 0, transform: 'translateX(-25%)' },
        //       { opacity: 1, transform: 'translateX(0)' }
        //     ];
        //     const imageOptions = {
        //       duration: 2000,
        //       easing: 'ease-out',
        //       fill: 'forwards'
        //     };
        //     const anim = imageAbout.animate(imageKeyframes, imageOptions);
        //     anim.onfinish = () => {
        //       imageAbout.style.opacity = '1';
        //       imageAbout.style.transform = 'translateX(0)';
        //     };
        //   }
        //
        //   const box = container.querySelector('.box');
        //   if (box) {
        //     box.style.opacity = '0';
        //     box.style.transform = 'translateX(25%)';
        //     box.style.animation = 'none';
        //     void box.offsetWidth;
        //
        //     const boxKeyframes = [
        //       { opacity: 0, transform: 'translateX(25%)' },
        //       { opacity: 1, transform: 'translateX(0)' }
        //     ];
        //     const boxOptions = {
        //       duration: 2000,
        //       easing: 'ease-out',
        //       fill: 'forwards'
        //     };
        //     const anim = box.animate(boxKeyframes, boxOptions);
        //     anim.onfinish = () => {
        //       box.style.opacity = '1';
        //       box.style.transform = 'translateX(0)';
        //     };
        //   }
        //
        //   // 标记已执行
        //   sessionStorage.setItem(hasAnimatedKey, 'true');
        //
        //   break;
//
//       const container = document.getElementById(containerId);
//       if (!container) return;
//
//       switch (containerId) {
//         case 'container1':
//           // ---  动画 ---
//           // --- image-about 动画 ---
//           const imageAbout = container.querySelector('.image-about');
//           if (imageAbout) {
//             imageAbout.style.opacity = '0';
//             imageAbout.style.transform = 'translateX(-25%)';
//             imageAbout.style.animation = 'none';
//             void imageAbout.offsetWidth;
//
//             const imageKeyframes = [
//               { opacity: 0, transform: 'translateX(-25%)' },
//               { opacity: 1, transform: 'translateX(0)' }
//             ];
//             const imageOptions = {
//               duration: 2000,
//               easing: 'ease-out',
//               fill: 'forwards'
//             };
//             const anim = imageAbout.animate(imageKeyframes, imageOptions);
//             anim.onfinish = () => {
//               imageAbout.style.opacity = '1';
//               imageAbout.style.transform = 'translateX(0)';
//             };
//           }
//
// // --- box 动画 ---
//           const box = container.querySelector('.box');
//           if (box) {
//             box.style.opacity = '0';
//             box.style.transform = 'translateX(25%)';
//             box.style.animation = 'none';
//             void box.offsetWidth;
//
//             const boxKeyframes = [
//               { opacity: 0, transform: 'translateX(25%)' },
//               { opacity: 1, transform: 'translateX(0)' }
//             ];
//             const boxOptions = {
//               duration: 2000,
//               easing: 'ease-out',
//               fill: 'forwards'
//             };
//             const anim = box.animate(boxKeyframes, boxOptions);
//             anim.onfinish = () => {
//               box.style.opacity = '1';
//               box.style.transform = 'translateX(0)';
//             };
//           }
//
//
//
//
//           break;
        case 'jingzheng':
          // ---  动画 ---
          const description = container.querySelector('.jingzheng-description');
          const subtext = container.querySelector('.jingzheng-AYa');
          const line = container.querySelector('.decorative-line');
          const content = container.querySelector('.jingzheng-content');

          const leftInOptions = {
            duration: 2000,
            easing: 'ease-out',
            fill: 'forwards'
          };

          const rightInOptions = {
            duration: 2000,
            easing: 'ease-out',
            fill: 'forwards'
          };

          // --- stat 动画（从下往上） ---
          // const statItems = container.querySelectorAll('.stat');
          // statItems.forEach((el, i) => {
          //   el.style.opacity = '0';
          //   el.style.transform = 'translateY(30%)';
          //   el.style.animation = 'none';
          //   void el.offsetWidth;
          //
          //   const keyframes = [
          //     { opacity: 0, transform: 'translateY(30%)' },
          //     { opacity: 1, transform: 'translateY(0)' }
          //   ];
          //   const options = {
          //     duration: 2000,
          //     easing: 'ease-out',
          //     fill: 'forwards',
          //     delay: i * 400 // 顺序进入
          //   };
          //
          //   const anim = el.animate(keyframes, options);
          //   anim.onfinish = () => {
          //     el.style.opacity = '1';
          //     el.style.transform = 'translateY(0)';
          //   };
          // });

          //数字递增
          this.stat.forEach((item, index) => {
            this.$set(item, 'currentNum', 0); // 确保响应式
            const target = item.num;
            const step = Math.ceil(target / 50);
            const interval = setInterval(() => {
              if (item.currentNum >= target) {
                item.currentNum = target;
                clearInterval(interval);
              } else {
                item.currentNum += step;
              }
            }, 100);
          });//结束

          // // 从左侧飞入的元素
          // [description, subtext, line].forEach((el, i) => {
          //   if (el) {
          //     el.style.opacity = '0';
          //     el.style.transform = 'translateX(-25%)';
          //     el.style.animation = 'none';
          //     void el.offsetWidth;
          //
          //     const keyframes = [
          //       { opacity: 0, transform: 'translateX(-25%)' },
          //       { opacity: 1, transform: 'translateX(0)' }
          //     ];
          //
          //     const anim = el.animate(keyframes, {
          //       ...leftInOptions,
          //       delay: i * 400 // 每个元素延迟一点时间
          //     });
          //
          //     anim.onfinish = () => {
          //       el.style.opacity = '1';
          //       el.style.transform = 'translateX(0)';
          //     };
          //   }
          // });
          //
          // // 从右侧飞入的背景图
          // if (content) {
          //   content.style.opacity = '0';
          //   content.style.transform = 'translateY(25%)';
          //   content.style.animation = 'none';
          //   void content.offsetWidth;
          //
          //   const keyframes = [
          //     { opacity: 0, transform: 'translateY(25%)' },
          //     { opacity: 1, transform: 'translateY(0)' }
          //   ];
          //
          //   const anim = content.animate(keyframes, rightInOptions);
          //
          //   anim.onfinish = () => {
          //     content.style.opacity = '1';
          //     content.style.transform = 'translateY(0)';
          //   };
          // }
          break;
        case 'ziyuanyoushi':
          // ---  动画 ---
          // const mainText = container.querySelector('.ziyuanyoushi-text');
          // const divider = container.querySelector('.divider');
          // const keyProgress = container.querySelector('.key-progress');
          // const contentRight = container.querySelector('.ziyuanyoushi-content');
          //
          // const leftInOptionsZY = {
          //   duration: 2000,
          //   easing: 'ease-out',
          //   fill: 'forwards'
          // };
          //
          // const rightInOptionsZY = {
          //   duration: 2000,
          //   easing: 'ease-out',
          //   fill: 'forwards'
          // };
          //
          // // 从左侧飞入的元素
          // [mainText, divider, keyProgress].forEach((el, i) => {
          //   if (el) {
          //     // 强制刷新状态
          //     el.style.opacity = '0';
          //     el.style.transform = 'translateX(-25%)';
          //     el.style.animation = 'none';
          //     el.getBoundingClientRect(); // 👈关键强制刷新
          //     void el.offsetWidth;
          //
          //     const keyframes = [
          //       { opacity: 0, transform: 'translateX(-25%)' },
          //       { opacity: 1, transform: 'translateX(0)' }
          //     ];
          //
          //     const anim = el.animate(keyframes, {
          //       ...leftInOptionsZY,
          //       delay: i * 200
          //     });
          //
          //     anim.onfinish = () => {
          //       el.style.opacity = '1';
          //       el.style.transform = 'translateX(0)';
          //     };
          //   }
          // });
          //
          //
          // // 从右侧飞入的背景图
          // if (contentRight) {
          //   contentRight.style.opacity = '0';
          //   contentRight.style.transform = 'translateY(25%)';
          //   contentRight.style.animation = 'none';
          //   void contentRight.offsetWidth;
          //
          //   const keyframes = [
          //     { opacity: 0, transform: 'translateY(25%)' },
          //     { opacity: 1, transform: 'translateY(0)' }
          //   ];
          //
          //   const anim = contentRight.animate(keyframes, rightInOptionsZY);
          //
          //   anim.onfinish = () => {
          //     contentRight.style.opacity = '1';
          //     contentRight.style.transform = 'translateY(0)';
          //   };
          // }
          break;
        case 'container6-new':
          // ---  动画 ---
          const resultTitle = container.querySelector('.result-title');
          const resultDescription = container.querySelector('.result-description');
          const bottomNew = container.querySelector('.bottom-new');
          const resultCardNew = container.querySelector('.result-card-new');

          const leftInOptions6 = {
            duration: 2000,
            easing: 'ease-out',
            fill: 'forwards'
          };

          const rightInOptions6 = {
            duration: 2000,
            easing: 'ease-out',
            fill: 'forwards'
          };

          // 左侧飞入的元素
          // [resultTitle, resultDescription].forEach((el, i) => {
          //   if (el) {
          //     el.style.opacity = '0';
          //     el.style.transform = 'translateX(-25%)';
          //     el.style.animation = 'none';
          //     void el.offsetWidth;
          //
          //     const keyframes = [
          //       { opacity: 0, transform: 'translateX(-25%)' },
          //       { opacity: 1, transform: 'translateX(0)' }
          //     ];
          //
          //     const anim = el.animate(keyframes, {
          //       ...leftInOptions6,
          //       delay: i * 200
          //     });
          //
          //     anim.onfinish = () => {
          //       el.style.opacity = '1';
          //       el.style.transform = 'translateX(0)';
          //     };
          //   }
          // });
          //
          // // 右侧飞入的元素
          // [bottomNew, resultCardNew].forEach((el, i) => {
          //   if (el) {
          //     el.style.opacity = '0';
          //     el.style.transform = 'translateX(25%)';
          //     el.style.animation = 'none';
          //     void el.offsetWidth;
          //
          //     const keyframes = [
          //       { opacity: 0, transform: 'translateX(25%)' },
          //       { opacity: 1, transform: 'translateX(0)' }
          //     ];
          //
          //     const anim = el.animate(keyframes, {
          //       ...rightInOptions6,
          //       delay: i * 200
          //     });
          //
          //     anim.onfinish = () => {
          //       el.style.opacity = '1';
          //       el.style.transform = 'translateX(0)';
          //     };
          //   }
          // });
          // 数字递增动画
          this.resultCardList.forEach((item, index) => {
            this.$set(item, 'currentNumber', 0); // 确保响应式
            const target = parseInt(item.number);
            const step = Math.ceil(target / 50);
            const interval = setInterval(() => {
              if (item.currentNumber >= target) {
                item.currentNumber = target;
                clearInterval(interval);
              } else {
                item.currentNumber += step;
              }
            }, 50);
          });

          break;
        case 'qudaoyoushi':
          // ---  动画 ---
          const channelText = container.querySelector('.qudaoyoushi-text');
          const channelKey = container.querySelector('.channel-key-kong');
          const channelPartners = container.querySelector('.channel-partners');
          const qudaoyoushiContent = container.querySelector('.qudaoyoushi-content');

          const leftInOptionsQD = {
            duration: 2000,
            easing: 'ease-out',
            fill: 'forwards'
          };

          const rightInOptionsQD = {
            duration: 2000,
            easing: 'ease-out',
            fill: 'forwards'
          };
          //
          // // 从左侧飞入的元素
          // [channelText, channelKey, channelPartners].forEach((el, i) => {
          //   if (el) {
          //     el.style.opacity = '0';
          //     el.style.transform = 'translateX(-25%)';
          //     el.style.animation = 'none';
          //     void el.offsetWidth;
          //
          //     const keyframes = [
          //       { opacity: 0, transform: 'translateX(-25%)' },
          //       { opacity: 1, transform: 'translateX(0)' }
          //     ];
          //
          //     const anim = el.animate(keyframes, {
          //       ...leftInOptionsQD,
          //       delay: i * 400 // 依次延迟
          //     });
          //
          //     anim.onfinish = () => {
          //       el.style.opacity = '1';
          //       el.style.transform = 'translateX(0)';
          //     };
          //   }
          // });
          //
          // // 从右侧飞入的背景图
          // if (qudaoyoushiContent) {
          //   qudaoyoushiContent.style.opacity = '0';
          //   qudaoyoushiContent.style.transform = 'translateY(25%)';
          //   qudaoyoushiContent.style.animation = 'none';
          //   void qudaoyoushiContent.offsetWidth;
          //
          //   const keyframes = [
          //     { opacity: 0, transform: 'translateY(25%)' },
          //     { opacity: 1, transform: 'translateY(0)' }
          //   ];
          //
          //   const anim = qudaoyoushiContent.animate(keyframes, rightInOptionsQD);
          //
          //   anim.onfinish = () => {
          //     qudaoyoushiContent.style.opacity = '1';
          //     qudaoyoushiContent.style.transform = 'translateY(0)';
          //   };
          // }

          break;
        case 'chanpingyoushi':
          // ---  动画 ---
          const boxCP = container.querySelector('.chanpingyoushi-box');
          const itemsCP = container.querySelectorAll('.chanpingyoushi-item');

          // 中心放大动画
          // if (boxCP) {
          //   boxCP.style.opacity = '0';
          //   boxCP.style.transform = 'scale(0.8)';
          //   boxCP.style.animation = 'none';
          //   void boxCP.offsetWidth;
          //
          //   const keyframes = [
          //     { opacity: 0, transform: 'scale(0.8)' },
          //     { opacity: 1, transform: 'scale(1)' }
          //   ];
          //
          //   const anim = boxCP.animate(keyframes, {
          //     duration: 2000,
          //     easing: 'ease-out',
          //     fill: 'forwards'
          //   });
          //
          //   anim.onfinish = () => {
          //     boxCP.style.opacity = '1';
          //     boxCP.style.transform = 'scale(1)';
          //   };
          // }
          //
          // // item 从下往上飞入
          // itemsCP.forEach((el, i) => {
          //   el.style.opacity = '0';
          //   el.style.transform = 'translateY(100%)';
          //   el.style.animation = 'none';
          //   void el.offsetWidth;
          //
          //   const keyframes = [
          //     { opacity: 0, transform: 'translateY(100%)' },
          //     { opacity: 1, transform: 'translateY(0)' }
          //   ];
          //
          //   const anim = el.animate(keyframes, {
          //     duration: 2000,
          //     easing: 'ease-out',
          //     fill: 'forwards',
          //     delay: i * 400
          //   });
          //
          //   anim.onfinish = () => {
          //     el.style.opacity = '1';
          //     el.style.transform = 'translateY(0)';
          //   };
          // });
          break;
        case 'container9':
          // ---  动画 ---
          // const bottomDescription = container.querySelector('.bottomDescription');
          // const dateDisplay = container.querySelector('.date-display');
          //
          // const leftInOptions9 = {
          //   duration: 2000,
          //   easing: 'ease-out',
          //   fill: 'forwards'
          // };
          //
          // const rightInOptions9 = {
          //   duration: 2000,
          //   easing: 'ease-out',
          //   fill: 'forwards'
          // };
          //
          // // bottomDescription 从左侧飞入
          // if (bottomDescription) {
          //   bottomDescription.style.opacity = '0';
          //   bottomDescription.style.transform = 'translateX(-100%)';
          //   bottomDescription.style.animation = 'none';
          //   void bottomDescription.offsetWidth;
          //
          //   const keyframes = [
          //     { opacity: 0, transform: 'translateX(-100%)' },
          //     { opacity: 1, transform: 'translateX(0)' }
          //   ];
          //
          //   const anim = bottomDescription.animate(keyframes, leftInOptions9);
          //   anim.onfinish = () => {
          //     bottomDescription.style.opacity = '1';
          //     bottomDescription.style.transform = 'translateX(0)';
          //   };
          // }
          //
          // // date-display 从右侧飞入
          // if (dateDisplay) {
          //   dateDisplay.style.opacity = '0';
          //   dateDisplay.style.transform = 'translateX(100%)';
          //   dateDisplay.style.animation = 'none';
          //   void dateDisplay.offsetWidth;
          //
          //   const keyframes = [
          //     { opacity: 0, transform: 'translateX(100%)' },
          //     { opacity: 1, transform: 'translateX(0)' }
          //   ];
          //
          //   const anim = dateDisplay.animate(keyframes, rightInOptions9);
          //   anim.onfinish = () => {
          //     dateDisplay.style.opacity = '1';
          //     dateDisplay.style.transform = 'translateX(0)';
          //   };
          // }
          break;

      }
    },
//     resetContainerAnimation(containerId) {
//       if (window.innerWidth < 768) return;
//       // if (window.innerWidth < 768) return; // 小屏幕不执行
//       const container = document.getElementById(containerId);
//       if (!container) return;
//
//       // 检查是否已经执行过动画（sessionStorage 在刷新后会清空）
//       const hasAnimatedKey = `hasAnimated-${containerId}`;
//       if (sessionStorage.getItem(hasAnimatedKey)) {
//         return; // 已经执行过动画，跳过
//       }
//
//       switch (containerId) {
//         case 'container1':
//           const imageAbout = container.querySelector('.image-about');
//           if (imageAbout) {
//             imageAbout.style.opacity = '0';
//             imageAbout.style.transform = 'translateX(-25%)';
//             imageAbout.style.animation = 'none';
//             void imageAbout.offsetWidth;
//
//             const imageKeyframes = [
//               { opacity: 0, transform: 'translateX(-25%)' },
//               { opacity: 1, transform: 'translateX(0)' }
//             ];
//             const imageOptions = {
//               duration: 2000,
//               easing: 'ease-out',
//               fill: 'forwards'
//             };
//             const anim = imageAbout.animate(imageKeyframes, imageOptions);
//             anim.onfinish = () => {
//               imageAbout.style.opacity = '1';
//               imageAbout.style.transform = 'translateX(0)';
//             };
//           }
//
//           const box = container.querySelector('.box');
//           if (box) {
//             box.style.opacity = '0';
//             box.style.transform = 'translateX(25%)';
//             box.style.animation = 'none';
//             void box.offsetWidth;
//
//             const boxKeyframes = [
//               { opacity: 0, transform: 'translateX(25%)' },
//               { opacity: 1, transform: 'translateX(0)' }
//             ];
//             const boxOptions = {
//               duration: 2000,
//               easing: 'ease-out',
//               fill: 'forwards'
//             };
//             const anim = box.animate(boxKeyframes, boxOptions);
//             anim.onfinish = () => {
//               box.style.opacity = '1';
//               box.style.transform = 'translateX(0)';
//             };
//           }
//
//           // 标记已执行
//           sessionStorage.setItem(hasAnimatedKey, 'true');
//
//           break;
// //
// //       const container = document.getElementById(containerId);
// //       if (!container) return;
// //
// //       switch (containerId) {
// //         case 'container1':
// //           // ---  动画 ---
// //           // --- image-about 动画 ---
// //           const imageAbout = container.querySelector('.image-about');
// //           if (imageAbout) {
// //             imageAbout.style.opacity = '0';
// //             imageAbout.style.transform = 'translateX(-25%)';
// //             imageAbout.style.animation = 'none';
// //             void imageAbout.offsetWidth;
// //
// //             const imageKeyframes = [
// //               { opacity: 0, transform: 'translateX(-25%)' },
// //               { opacity: 1, transform: 'translateX(0)' }
// //             ];
// //             const imageOptions = {
// //               duration: 2000,
// //               easing: 'ease-out',
// //               fill: 'forwards'
// //             };
// //             const anim = imageAbout.animate(imageKeyframes, imageOptions);
// //             anim.onfinish = () => {
// //               imageAbout.style.opacity = '1';
// //               imageAbout.style.transform = 'translateX(0)';
// //             };
// //           }
// //
// // // --- box 动画 ---
// //           const box = container.querySelector('.box');
// //           if (box) {
// //             box.style.opacity = '0';
// //             box.style.transform = 'translateX(25%)';
// //             box.style.animation = 'none';
// //             void box.offsetWidth;
// //
// //             const boxKeyframes = [
// //               { opacity: 0, transform: 'translateX(25%)' },
// //               { opacity: 1, transform: 'translateX(0)' }
// //             ];
// //             const boxOptions = {
// //               duration: 2000,
// //               easing: 'ease-out',
// //               fill: 'forwards'
// //             };
// //             const anim = box.animate(boxKeyframes, boxOptions);
// //             anim.onfinish = () => {
// //               box.style.opacity = '1';
// //               box.style.transform = 'translateX(0)';
// //             };
// //           }
// //
// //
// //
// //
// //           break;
//         case 'jingzheng':
//           // ---  动画 ---
//           const description = container.querySelector('.jingzheng-description');
//           const subtext = container.querySelector('.jingzheng-AYa');
//           const line = container.querySelector('.decorative-line');
//           const content = container.querySelector('.jingzheng-content');
//
//           const leftInOptions = {
//             duration: 2000,
//             easing: 'ease-out',
//             fill: 'forwards'
//           };
//
//           const rightInOptions = {
//             duration: 2000,
//             easing: 'ease-out',
//             fill: 'forwards'
//           };
//
//           // --- stat 动画（从下往上） ---
//           const statItems = container.querySelectorAll('.stat');
//           statItems.forEach((el, i) => {
//             el.style.opacity = '0';
//             el.style.transform = 'translateY(30%)';
//             el.style.animation = 'none';
//             void el.offsetWidth;
//
//             const keyframes = [
//               { opacity: 0, transform: 'translateY(30%)' },
//               { opacity: 1, transform: 'translateY(0)' }
//             ];
//             const options = {
//               duration: 2000,
//               easing: 'ease-out',
//               fill: 'forwards',
//               delay: i * 400 // 顺序进入
//             };
//
//             const anim = el.animate(keyframes, options);
//             anim.onfinish = () => {
//               el.style.opacity = '1';
//               el.style.transform = 'translateY(0)';
//             };
//           });
//
//           //数字递增
//           this.stat.forEach((item, index) => {
//             this.$set(item, 'currentNum', 0); // 确保响应式
//             const target = item.num;
//             const step = Math.ceil(target / 50);
//             const interval = setInterval(() => {
//               if (item.currentNum >= target) {
//                 item.currentNum = target;
//                 clearInterval(interval);
//               } else {
//                 item.currentNum += step;
//               }
//             }, 100);
//           });//结束
//
//           // 从左侧飞入的元素
//           [description, subtext, line].forEach((el, i) => {
//             if (el) {
//               el.style.opacity = '0';
//               el.style.transform = 'translateX(-25%)';
//               el.style.animation = 'none';
//               void el.offsetWidth;
//
//               const keyframes = [
//                 { opacity: 0, transform: 'translateX(-25%)' },
//                 { opacity: 1, transform: 'translateX(0)' }
//               ];
//
//               const anim = el.animate(keyframes, {
//                 ...leftInOptions,
//                 delay: i * 400 // 每个元素延迟一点时间
//               });
//
//               anim.onfinish = () => {
//                 el.style.opacity = '1';
//                 el.style.transform = 'translateX(0)';
//               };
//             }
//           });
//
//           // 从右侧飞入的背景图
//           if (content) {
//             content.style.opacity = '0';
//             content.style.transform = 'translateY(25%)';
//             content.style.animation = 'none';
//             void content.offsetWidth;
//
//             const keyframes = [
//               { opacity: 0, transform: 'translateY(25%)' },
//               { opacity: 1, transform: 'translateY(0)' }
//             ];
//
//             const anim = content.animate(keyframes, rightInOptions);
//
//             anim.onfinish = () => {
//               content.style.opacity = '1';
//               content.style.transform = 'translateY(0)';
//             };
//           }
//           break;
//         case 'ziyuanyoushi':
//           // ---  动画 ---
//           const mainText = container.querySelector('.ziyuanyoushi-text');
//           const divider = container.querySelector('.divider');
//           const keyProgress = container.querySelector('.key-progress');
//           const contentRight = container.querySelector('.ziyuanyoushi-content');
//
//           const leftInOptionsZY = {
//             duration: 2000,
//             easing: 'ease-out',
//             fill: 'forwards'
//           };
//
//           const rightInOptionsZY = {
//             duration: 2000,
//             easing: 'ease-out',
//             fill: 'forwards'
//           };
//
//           // 从左侧飞入的元素
//           [mainText, divider, keyProgress].forEach((el, i) => {
//             if (el) {
//               // 强制刷新状态
//               el.style.opacity = '0';
//               el.style.transform = 'translateX(-25%)';
//               el.style.animation = 'none';
//               el.getBoundingClientRect(); // 👈关键强制刷新
//               void el.offsetWidth;
//
//               const keyframes = [
//                 { opacity: 0, transform: 'translateX(-25%)' },
//                 { opacity: 1, transform: 'translateX(0)' }
//               ];
//
//               const anim = el.animate(keyframes, {
//                 ...leftInOptionsZY,
//                 delay: i * 200
//               });
//
//               anim.onfinish = () => {
//                 el.style.opacity = '1';
//                 el.style.transform = 'translateX(0)';
//               };
//             }
//           });
//
//
//           // 从右侧飞入的背景图
//           if (contentRight) {
//             contentRight.style.opacity = '0';
//             contentRight.style.transform = 'translateY(25%)';
//             contentRight.style.animation = 'none';
//             void contentRight.offsetWidth;
//
//             const keyframes = [
//               { opacity: 0, transform: 'translateY(25%)' },
//               { opacity: 1, transform: 'translateY(0)' }
//             ];
//
//             const anim = contentRight.animate(keyframes, rightInOptionsZY);
//
//             anim.onfinish = () => {
//               contentRight.style.opacity = '1';
//               contentRight.style.transform = 'translateY(0)';
//             };
//           }
//           break;
//         case 'container6-new':
//           // ---  动画 ---
//           const resultTitle = container.querySelector('.result-title');
//           const resultDescription = container.querySelector('.result-description');
//           const bottomNew = container.querySelector('.bottom-new');
//           const resultCardNew = container.querySelector('.result-card-new');
//
//           const leftInOptions6 = {
//             duration: 2000,
//             easing: 'ease-out',
//             fill: 'forwards'
//           };
//
//           const rightInOptions6 = {
//             duration: 2000,
//             easing: 'ease-out',
//             fill: 'forwards'
//           };
//
//           // 左侧飞入的元素
//           [resultTitle, resultDescription].forEach((el, i) => {
//             if (el) {
//               el.style.opacity = '0';
//               el.style.transform = 'translateX(-25%)';
//               el.style.animation = 'none';
//               void el.offsetWidth;
//
//               const keyframes = [
//                 { opacity: 0, transform: 'translateX(-25%)' },
//                 { opacity: 1, transform: 'translateX(0)' }
//               ];
//
//               const anim = el.animate(keyframes, {
//                 ...leftInOptions6,
//                 delay: i * 200
//               });
//
//               anim.onfinish = () => {
//                 el.style.opacity = '1';
//                 el.style.transform = 'translateX(0)';
//               };
//             }
//           });
//
//           // 右侧飞入的元素
//           [bottomNew, resultCardNew].forEach((el, i) => {
//             if (el) {
//               el.style.opacity = '0';
//               el.style.transform = 'translateX(25%)';
//               el.style.animation = 'none';
//               void el.offsetWidth;
//
//               const keyframes = [
//                 { opacity: 0, transform: 'translateX(25%)' },
//                 { opacity: 1, transform: 'translateX(0)' }
//               ];
//
//               const anim = el.animate(keyframes, {
//                 ...rightInOptions6,
//                 delay: i * 200
//               });
//
//               anim.onfinish = () => {
//                 el.style.opacity = '1';
//                 el.style.transform = 'translateX(0)';
//               };
//             }
//           });
//           // 数字递增动画
//           this.resultCardList.forEach((item, index) => {
//             this.$set(item, 'currentNumber', 0); // 确保响应式
//             const target = parseInt(item.number);
//             const step = Math.ceil(target / 50);
//             const interval = setInterval(() => {
//               if (item.currentNumber >= target) {
//                 item.currentNumber = target;
//                 clearInterval(interval);
//               } else {
//                 item.currentNumber += step;
//               }
//             }, 50);
//           });
//
//           break;
//         case 'qudaoyoushi':
//           // ---  动画 ---
//           const channelText = container.querySelector('.qudaoyoushi-text');
//           const channelKey = container.querySelector('.channel-key-kong');
//           const channelPartners = container.querySelector('.channel-partners');
//           const qudaoyoushiContent = container.querySelector('.qudaoyoushi-content');
//
//           const leftInOptionsQD = {
//             duration: 2000,
//             easing: 'ease-out',
//             fill: 'forwards'
//           };
//
//           const rightInOptionsQD = {
//             duration: 2000,
//             easing: 'ease-out',
//             fill: 'forwards'
//           };
//
//           // 从左侧飞入的元素
//           [channelText, channelKey, channelPartners].forEach((el, i) => {
//             if (el) {
//               el.style.opacity = '0';
//               el.style.transform = 'translateX(-25%)';
//               el.style.animation = 'none';
//               void el.offsetWidth;
//
//               const keyframes = [
//                 { opacity: 0, transform: 'translateX(-25%)' },
//                 { opacity: 1, transform: 'translateX(0)' }
//               ];
//
//               const anim = el.animate(keyframes, {
//                 ...leftInOptionsQD,
//                 delay: i * 400 // 依次延迟
//               });
//
//               anim.onfinish = () => {
//                 el.style.opacity = '1';
//                 el.style.transform = 'translateX(0)';
//               };
//             }
//           });
//
//           // 从右侧飞入的背景图
//           if (qudaoyoushiContent) {
//             qudaoyoushiContent.style.opacity = '0';
//             qudaoyoushiContent.style.transform = 'translateY(25%)';
//             qudaoyoushiContent.style.animation = 'none';
//             void qudaoyoushiContent.offsetWidth;
//
//             const keyframes = [
//               { opacity: 0, transform: 'translateY(25%)' },
//               { opacity: 1, transform: 'translateY(0)' }
//             ];
//
//             const anim = qudaoyoushiContent.animate(keyframes, rightInOptionsQD);
//
//             anim.onfinish = () => {
//               qudaoyoushiContent.style.opacity = '1';
//               qudaoyoushiContent.style.transform = 'translateY(0)';
//             };
//           }
//
//           break;
//         case 'chanpingyoushi':
//           // ---  动画 ---
//           const boxCP = container.querySelector('.chanpingyoushi-box');
//           const itemsCP = container.querySelectorAll('.chanpingyoushi-item');
//
//           // 中心放大动画
//           if (boxCP) {
//             boxCP.style.opacity = '0';
//             boxCP.style.transform = 'scale(0.8)';
//             boxCP.style.animation = 'none';
//             void boxCP.offsetWidth;
//
//             const keyframes = [
//               { opacity: 0, transform: 'scale(0.8)' },
//               { opacity: 1, transform: 'scale(1)' }
//             ];
//
//             const anim = boxCP.animate(keyframes, {
//               duration: 2000,
//               easing: 'ease-out',
//               fill: 'forwards'
//             });
//
//             anim.onfinish = () => {
//               boxCP.style.opacity = '1';
//               boxCP.style.transform = 'scale(1)';
//             };
//           }
//
//           // item 从下往上飞入
//           itemsCP.forEach((el, i) => {
//             el.style.opacity = '0';
//             el.style.transform = 'translateY(100%)';
//             el.style.animation = 'none';
//             void el.offsetWidth;
//
//             const keyframes = [
//               { opacity: 0, transform: 'translateY(100%)' },
//               { opacity: 1, transform: 'translateY(0)' }
//             ];
//
//             const anim = el.animate(keyframes, {
//               duration: 2000,
//               easing: 'ease-out',
//               fill: 'forwards',
//               delay: i * 400
//             });
//
//             anim.onfinish = () => {
//               el.style.opacity = '1';
//               el.style.transform = 'translateY(0)';
//             };
//           });
//           break;
//         case 'container9':
//           // ---  动画 ---
//           const bottomDescription = container.querySelector('.bottomDescription');
//           const dateDisplay = container.querySelector('.date-display');
//
//           const leftInOptions9 = {
//             duration: 2000,
//             easing: 'ease-out',
//             fill: 'forwards'
//           };
//
//           const rightInOptions9 = {
//             duration: 2000,
//             easing: 'ease-out',
//             fill: 'forwards'
//           };
//
//           // bottomDescription 从左侧飞入
//           if (bottomDescription) {
//             bottomDescription.style.opacity = '0';
//             bottomDescription.style.transform = 'translateX(-100%)';
//             bottomDescription.style.animation = 'none';
//             void bottomDescription.offsetWidth;
//
//             const keyframes = [
//               { opacity: 0, transform: 'translateX(-100%)' },
//               { opacity: 1, transform: 'translateX(0)' }
//             ];
//
//             const anim = bottomDescription.animate(keyframes, leftInOptions9);
//             anim.onfinish = () => {
//               bottomDescription.style.opacity = '1';
//               bottomDescription.style.transform = 'translateX(0)';
//             };
//           }
//
//           // date-display 从右侧飞入
//           if (dateDisplay) {
//             dateDisplay.style.opacity = '0';
//             dateDisplay.style.transform = 'translateX(100%)';
//             dateDisplay.style.animation = 'none';
//             void dateDisplay.offsetWidth;
//
//             const keyframes = [
//               { opacity: 0, transform: 'translateX(100%)' },
//               { opacity: 1, transform: 'translateX(0)' }
//             ];
//
//             const anim = dateDisplay.animate(keyframes, rightInOptions9);
//             anim.onfinish = () => {
//               dateDisplay.style.opacity = '1';
//               dateDisplay.style.transform = 'translateX(0)';
//             };
//           }
//           break;
//
//       }
//     },
    scrollToElement(containerId, index) {
      const element = document.getElementById(containerId);
      if (!element) return;

      const elementTop    = element.getBoundingClientRect().top + window.scrollY;
      const elementHeight = element.offsetHeight;
      const screenHeight  = window.innerHeight;

      // 如果是第一个容器，滚到顶部；否则滚到垂直居中
      let scrollTo;
      if ((index === 0 || index === 1) /* 或者 containerId === 'A' */) {
        scrollTo = elementTop;
      } else {
        scrollTo = elementTop - (screenHeight / 2) + (elementHeight / 2);
      }

      window.scrollTo({
        top: scrollTo,
        behavior: 'smooth'
      });

      this.activeIndex = index;
    },

    updateActiveIndex() {
      const containers = ['A','container1', 'jingzheng', 'ziyuanyoushi', 'container6-new', 'qudaoyoushi', 'chanpingyoushi','container9','B'];
      const viewportCenter = window.scrollY + window.innerHeight / 2;

      containers.forEach((id, index) => {
        const element = document.getElementById(id);
        if (element) {
          const elementTop = element.offsetTop;
          const elementBottom = elementTop + element.offsetHeight;

          // 判断元素是否覆盖视口中点
          if (viewportCenter >= elementTop && viewportCenter < elementBottom) {
            this.activeIndex = index;
          }
        }
      });
    },

    handleScroll(event) {
      // 1）小屏幕不管
      this.screenWidth = window.innerWidth;
      this.screenHeight = window.innerHeight;  // 更新屏幕高度
      if (this.screenWidth <= 1200 || this.screenHeight <= 1000) return;

      const now = Date.now();
      // 如果还在冷却期，直接跳过
      if (now - this.lastScrollTime < this.scrollCooldown) {
        event.preventDefault();
        return;
      }

      // 2）累积滚动 delta
      this.scrollDeltaAccumulator += event.deltaY;
      // 只有当累积值超过阈值时，才算一次"向上"或"向下"
      if (Math.abs(this.scrollDeltaAccumulator) < this.scrollThreshold) {
        // 没到阈值，什么也不做
        event.preventDefault();
        return;
      }

      // 3）真正要触发一次翻屏切换
      const delta = this.scrollDeltaAccumulator;
      // 重置累积
      this.scrollDeltaAccumulator = 0;
      // 记录触发时刻，进入冷却期
      this.lastScrollTime = now;

      // 以下逻辑跟你原来的一模一样，只不过把对 delta >0 / <0 的判断放在这里
      const containers = ['A','container1','jingzheng','ziyuanyoushi','container6-new','qudaoyoushi','chanpingyoushi','container9','B'];
      let targetIndex = this.activeIndex;

      if (delta > 0) {
        // 向下滚
        if (window.scrollY === 0) {
          targetIndex = 0;
          this.scrollTopCounter = 0;
          this.scrollBottomCounter = 0;
        } else if (containers[this.activeIndex] === 'chanpingyoushi') {
          this.scrollBottomCounter = (this.scrollBottomCounter||0) + 1;
          if (this.scrollBottomCounter === 1) {
            window.scrollTo({ top: document.documentElement.scrollHeight, behavior: 'smooth' });
            return;
          }
        } else if (this.activeIndex < containers.length - 1) {
          targetIndex = this.activeIndex + 1;
          this.scrollTopCounter = this.scrollBottomCounter = 0;
        }
      } else {
        // 向上滚
        if (containers[this.activeIndex] === 'container1') {
          this.scrollTopCounter = (this.scrollTopCounter||0) + 1;
          if (this.scrollTopCounter === 1) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            return;
          }
        } else if (this.activeIndex > 0) {
          targetIndex = this.activeIndex - 1;
          this.scrollTopCounter = this.scrollBottomCounter = 0;
        }
      }

      // 复位动画状态
      this.containerAnimationStates[containers[targetIndex]] = false;
      // 滚到目标
      this.scrollToElement(containers[targetIndex], targetIndex);
      this.activeIndex = targetIndex;
    },

    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },

    handleResize() {
      this.windowWidth = window.innerWidth; // 更新窗口宽度
      const wasMobile = this.isMobile;
      this.isMobile = window.innerWidth <= 768;

      // 如果从移动端切换到桌面端，重新启动两个动画
      if (wasMobile && !this.isMobile) {
        this.startStatAnimation();
        this.startResultAnimation();
      }
      // 如果从桌面端切换到移动端，直接设置两个数组的目标值
      else if (!wasMobile && this.isMobile) {
        this.stat.forEach(item => {
          item.currentNum = item.num;
        });
        this.resultCardList.forEach(item => {
          item.currentNumber = item.number;
        });
      }
    },
    handleResizeP() {
      this.windowWidth = window.innerWidth; // 更新窗口宽度

      // 如果窗口宽度大于等于 768，认为是桌面端，启动动画
      if (this.windowWidth >= 769) {
        this.startStatAnimation();
        this.startResultAnimation();
      }
    },
    updateScale() {
      const widthScale = window.innerWidth / this.designWidth;
      const heightScale = window.innerHeight / this.designHeight;
      this.scale = Math.min(widthScale, heightScale);
    },
    updateDate() {
      const now = new Date();
      // Format the current day with leading zero if needed
      this.currentDay = String(now.getDate()).padStart(2, '0');
      // Get current month with leading zero if needed
      this.currentMonth = String(now.getMonth() + 1).padStart(2, '0');

    },

    // 启动 stat 数组的动画
    startStatAnimation() {
      if (this.isMobile) {
        this.stat.forEach(item => {
          item.currentNum = item.num;
        });
        return;
      }

      this.stat.forEach(item => {
        let start = 0;
        const end = item.num;
        const duration = 2000;
        const startTime = performance.now();

        const animate = (currentTime) => {
          const elapsed = currentTime - startTime;
          const progress = Math.min(elapsed / duration, 1);
          const easeProgress = this.easeOutQuad(progress);
          item.currentNum = Math.floor(easeProgress * end);

          if (progress < 1) {
            requestAnimationFrame(animate);
          } else {
            item.currentNum = end;
          }
        };

        requestAnimationFrame(animate);
      });
    },
    // 缓动函数：easeOutQuad
    easeOutQuad(t) {
      return t * (2 - t);
    },

    // 启动 resultCardList 数组的动画
    startResultAnimation() {
      if (this.isMobile) {
        this.resultCardList.forEach(item => {
          item.currentNumber = item.number;
        });
        return;
      }

      this.resultCardList.forEach(item => {
        let start = 0;
        const end = item.number;
        const duration = 2000;
        const startTime = performance.now();

        const animate = (currentTime) => {
          const elapsed = currentTime - startTime;
          const progress = Math.min(elapsed / duration, 1);
          const easeProgress = this.easeOutQuad(progress);
          item.currentNumber = Math.floor(easeProgress * end);

          if (progress < 1) {
            requestAnimationFrame(animate);
          } else {
            item.currentNumber = end;
          }
        };

        requestAnimationFrame(animate);
      });
    },

    // 检查元素是否在视口中
    isInViewport(element) {
      const rect = element.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    },

    // // 监听滚动事件
    handleScrollA() {
      const statElement = this.$el.querySelector('.stat-container');
      const resultElement = this.$el.querySelector('.result-card-container');

      // 检查 stat 数组的动画
      if (!this.statAnimationStarted && statElement && this.isInViewport(statElement)) {
        this.statAnimationStarted = true;
        this.startStatAnimation();
      }

      // 检查 resultCardList 数组的动画
      if (!this.resultAnimationStarted && resultElement && this.isInViewport(resultElement)) {
        this.resultAnimationStarted = true;
        this.startResultAnimation();
      }
    }
  },
  created() {

  },

  mounted() {

    this.handleResizeP();
    this.setupIntersectionObservers();

    window.addEventListener('resize', () => {
      this.updateScale();
      this.handleResize();
    });

    window.addEventListener('scroll', this.updateActiveIndex);
    this.updateActiveIndex();
    window.addEventListener('wheel', this.handleScroll);
    this.handleResize();

    const container1 = this.$el.querySelector(".container1");
    if (container1) {
      container1.querySelector(".image-about").style.animation = "slideInLeft 1s ease forwards";
      container1.querySelector(".content").style.animation = "slideInRight 1s ease forwards";
    }

    this.updateDate();
    setInterval(this.updateDate, 1000);
  },


  beforeDestroy() {
    // 移除所有事件监听，防止内存泄漏
    window.removeEventListener('resize', this.updateScreenSize);
    window.removeEventListener('resize', this.updateScale);
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('scroll', this.updateActiveIndex);
    window.removeEventListener('wheel', this.handleScroll);

    clearInterval(this.dateInterval);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('scroll', this.updateActiveIndex);
    window.removeEventListener('wheel', this.handleScroll);
  },

  toggleSearch() {
    this.showSearch = !this.showSearch;
  },
  toggleMobileMenu() {
    this.showMobileMenu = !this.showMobileMenu;
  },
  handleResize() {
    this.screenWidth = window.innerWidth;
  },


};
</script>

<style lang="less" scoped>
@import "@/assets/fontsize/aboutHaiLin.less";  /* ✅ 正确引入变量定义 */
.banner-container{
  margin-bottom: 0;
}

.CaiDan{
  width: 100%;
  font-weight: 400;
  display: flex;
  justify-content: center;
  align-items: center;

}
.imgAbout{
  width: 100%;
}
/* 置顶按钮样式 */
.back-to-top {
  position: fixed;
  bottom: 40px;
  right: 30px;
  width: 40px;
  height: 40px;
  background-color: #00a0fa;
  color: white;
  font-size: 20px;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s;
}

.back-to-top:hover {
  background-color: #007fd1;
}

/* 添加全局数字和英文字体样式 */
.nav-item-H{
  display: none;
}
* {
  font-family: 'SourceHanSansCN', sans-serif;
}
html {
  scroll-behavior: smooth;
}
.container-1{
  padding: 0 0 80px 0;
}
.jingzheng{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  min-height: 900px;
}
.ziyuanyoushi{
  padding: 100px 0;
}
.container6-new{
  height: 100vh;
  padding:20px 0;
}
.qudaoyoushi{
  padding:60px 0;
}
.chanpingyoushi{
  padding:150px 0;
  margin-bottom: 80px;
}
.A{
  width: 100%;
  height: auto;
}
.B{
  width: 100%;
  height:2px;
}
.vertical-nav {
  position: fixed;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  padding: 10px;
  z-index: 1000;
}

.nav-item {
  cursor: pointer;
  padding: 20px 20px 20px 0;
  border-radius: 5px;
  text-align: center;
}

.nav-circle {
  width: 8px;
  height: 8px;
  background: linear-gradient(to bottom, #13a5e4, #40ae45);
  border-radius: 50%;
  margin: 0 auto;
}
/* 鼠标悬停时显示另一张图 */
.nav-circle:hover {
  width: 8px;
  height: 8px;
  background: linear-gradient(to bottom, #13a5e4, #40ae45);
}

/* 当前激活项显示图片 */
.nav-item.active .nav-circle {
  width: 20px;
  height: 20px;
  background-color: transparent;
  background-image: url('@/assets/home/activeDot.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
}
@media screen and (max-width: 1200px){
  .vertical-nav{
    display: none;
  }
}

.channel-partners{
  position: absolute;
  top: 71%;

}
.about-hailin-page {
  padding: 0;
  align-items: center;
  justify-content: center;
  overflow-x: hidden;
  width: 100%;
}

.container1 {
  position: relative;
  margin: 0 auto;
  width: 90%;
  max-width: 1400px;
  display: flex;
  align-items: stretch;
  background-color: white;
 /* height:700px;*/
  /*overflow: hidden;*/
  margin-bottom: 100px;

}

.content-background {
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  margin-right: -30%;
  height: calc(160px + 100% );
  background-color: #f8f8f8;
  z-index: 1;
  margin-top: -60px;

}
/* 定义从左边滑动进来的动画 */
@keyframes slideInLeft {
  from {
    transform: translateX(-100%); /* 从左边100%的位置开始 */
    opacity: 0; /* 初始透明度为0 */
  }
  to {
    transform: translateX(0); /* 滑动到原位置 */
    opacity: 1; /* 最终透明度为1 */
  }
}

/* 定义从右边滑动进来的动画 */
@keyframes slideInRight {
  from {
    transform: translateX(100%); /* 从右边100%的位置开始 */
    opacity: 0; /* 初始透明度为0 */
  }
  to {
    transform: translateX(0); /* 滑动到原位置 */
    opacity: 1; /* 最终透明度为1 */
  }
}
.image-about {
  position: relative;
  object-fit: cover;
  z-index: 2;
  max-width: 952px;
  padding: 80px 0 0 0;

}
.box {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-top: 0;
  margin-bottom: -60px;
}
.image-about {
  animation: slideInLeft 2s ease-out forwards;
}

.box {
  animation: slideInRight 2s ease-out forwards;
}
.content {
  /*position: absolute;*/
  left: 0;
  top:0;
  width: 100%;
  padding-left: 98px;
}

.content h1:first-child {
  font-size:@titleA-fontsize;
  font-family: "Source Han Sans CN";
  color: rgb(0, 160, 250);
  line-height:@title-font-line-height;
  font-weight: @title-font-weight;
  text-align: left;
  z-index: 16;
  padding-top: 70px;
}

.content h1:nth-child(2) {
  font-size:@title-fontsize;
  font-family: "Source Han Sans CN";
  color: rgb(0, 160, 250);
  line-height:@title-font-line-height;
  font-weight: @title-font-weight;
  text-align: left;
  z-index: 16;
}

.content p {
  font-size: @text-fontsize;
  line-height:@text-font-line-height;
  font-weight: @text-font-weight;
  font-family: "Source Han Sans CN";
  color: rgb(77, 77, 77);
  text-align: justify;
  margin-top: 30px;

}



.container2{
  width:80%;
  margin: 0 auto;
  text-align: center;
  justify-content: center;
  align-content: center;
}
.title01 {
  font-size: @logo-fontsize;
  line-height:@logo-font-line-height;
  font-weight: @logo-font-weight;
  margin-top:2vw;
  margin-bottom:2vw;
  color: black;
  background: url("@/tu/1x/about/logo.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  height: 9vw;
  width: auto;
}
.description {
  font-size: 1.5vw;
  margin: 0;
  padding: 0;
  color: #4d4d4d;
  line-height: 2.8vw;
}
.badges {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5vw;
  justify-content: center;
  margin-top: 10px;

}
.badge {
  font-size: @badge-fontsize;
  font-family: "Source Han Sans CN";
  color: rgb(255, 255, 255);
  line-height: @badge-font-line-height;
  font-weight: @badge-font-weight;
  background-color: #00a0fa; /* 初始背景色 */
  padding: 15px 20px;
  border-radius: 14px;
  white-space: nowrap; /* 防止文本换行 */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  margin: 10px;
  flex: 0 0 auto; /* 不允许缩小 */
  min-width: 8vw; /* 最小宽度 */
  text-align: center;
  transition: background-color 0.3s ease;
}
.badge:hover {
  background: linear-gradient(to right,
  #0056b3 0%,
  #003380 50%,
  #0056b3 100%);
}
.stats-box{
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
}
.stats {
  max-width: 1400px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  margin: 5px;
}

.stat {
  width: auto;
  text-align: center;
  margin: 10px 40px;
}
.stat-box{
  display: flex;
  flex-direction: row;
  align-items: center;
}
.stat-value-right{
  white-space: nowrap;
  text-align: left;
  margin: 0 20px ;

}
.stat-about{
  font-size:@numberText-fontsize;
  font-family: "Source Han Sans CN";
  color: rgb(77, 77, 77);
  line-height:@number-font-line-height;
  text-align: Left;
  margin-top: 10px;
}
.stat-icon {
  color: rgb(77, 77, 77);
}
.stat-icon img {
  width: 90px;
  height: auto;
}
.stat-value {
  font-size:@number-fontsize;
  font-family: "Alimama FangYuanTi VF";
  color: rgb(0, 160, 250);
  font-weight: bolder;
  line-height: @number-font-line-height;
  text-align: Left;
  z-index: 163;
}
.stat-value-el {
  font-size:@numberText-fontsize;
  font-weight: @number-font-weight;
  line-height: @number-font-line-height;
  color:  #00a0fa;
  margin-left: 5px;
}

.cards {
  padding:0 5%;
  width: 100%;
  height: 35vw;
  position: relative;
  display: flex;
  flex-direction: row;
}

.card {
  background-color: #F6F7F9;
  color: #333;
  border-radius: 1vw;
  width: 30vw;
  margin: 3vw 1.2vw 1vw 1.2vw;
  padding: 1vw;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  text-align: left;
}

.card h2 {
  position: absolute;
  top:20%;
  color: #00a0fa;
  font-size: 2vw;
  margin-bottom: 0.5vw;
}
.enTT {
  position: absolute;
  top:28%;
  white-space: nowrap;
  font-size: 1.2vw;
  text-align: left;
  color: #00a0fa;
}
.enTTAfter{
  position: relative;
  top:30%;
}
.card p {
  width: 24vw;
  font-size: 1.3vw;
  line-height: 1.5;
}

.card-row {
  gap:20px;
  margin-top: 1vw;
}

.card-row p {
  width: 10vw;
  position: absolute;
  top:60%;
  font-size: 1vw;
}
.card-imgYa {
  width: 10vw;
  height: auto;
  position: relative;
  animation: pulse 2s infinite ease-in-out; /* 添加无限循环的动态放大缩小动画 */
}

.card-imgYa:hover {
  animation: none; /* 鼠标悬浮时停止动画 */
  transform: scale(1.2); /* 鼠标悬浮时放大到1.2倍 */
  transition: transform 0.3s ease; /* 添加平滑的过渡效果 */
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1); /* 初始和结束时的大小 */
  }
  50% {
    transform: scale(1.1); /* 中间放大到1.1倍 */
  }
}

.infographic {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}


.tactics-Img-About {
  /* 初始状态：透明 */
  opacity: 0;
  /* 添加淡入动画 */
  animation: fadeIn 1s ease forwards;
}

/* 定义淡入动画 */
@keyframes fadeIn {
  from {
    opacity: 0; /* 初始透明度为0 */
  }
  to {
    opacity: 1; /* 最终透明度为1 */
  }
}
.tactics-box{
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center; /* 垂直居中 */
  justify-content: center;
  margin-top: -3vw;
  margin-bottom: -3vw;
}
.circle-container {
  display: flex;
  position: relative;
  width: 20vw; /* 以最大圆的尺寸为参考 */
  height: 20vw;
  align-items: center; /* 垂直居中 */
  justify-content: center; /* 水平居中 */
}
.circle {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); /* 让圆心对齐 */
  border-radius: 50%;
}

.circle1 {
  background-color:#00a0fa;
  width: 21vw;
  height: 21vw;
}

.circle2 {
  background-color: rgba(0, 123, 255, 0.6);
  width: 25vw;
  height: 25vw;
}
.tactics-title {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); /* 居中 */
  color: white; /* 文字颜色 */
  font-size: 3vw; /* 适当调整字体大小 */
  white-space: nowrap;
  font-weight: bold;
  z-index: 10; /* 确保文字不会被遮挡 */


}
.tacticsp{
  margin: 1vw;
}
.sectionleft {
  width: 30vw;
  display: flex;
  flex-direction: row;
  flex: 1;
  text-align: center;
  padding: 0;
  justify-content: center;
  align-items: center;
  background: url("@/assets/about/zuo.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position:70% 50%;
}
.sectionright {
  width:30vw;
  display: flex;
  flex-direction: row;
  flex: 1;
  text-align: center;
  padding: 0;
  justify-content: center;
  align-items: center;
  background: url("@/tu/1x/about/you.png");
  background-size:contain;
  background-repeat: no-repeat;
  background-position:30% 50%;


}
.lefttitle{
  font-size: 2.6vw;
  width: 2.5vw;
  margin-right: 0.5vw;
  margin-left: 0.5vw;
  color: #3DBB3D;
}
.sectionlistleft{
  width: 30vw;
  text-align: right;
  justify-content: center;
  align-items: center;
}
.righttitle{
  font-size: 2.6vw;
  width: 2.5vw;
  margin-right: 0.5vw;
  margin-left: 0.5vw;
  color: #00a0fa;

}

.sectionlistright{
  width: 30vw;
  text-align: left;
  color: gray;
  justify-content: center;
  align-items: center;

}
 h4 {
  font-size: 1.6vw;
  margin: 3px;
  color:#595757 ;
  white-space: nowrap;
  line-height: 0.2;
}
.lir1 h5{
  font-size: 1vw;
  margin: 0.5vw;
  line-height: 1;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  margin: 6px;
  white-space: nowrap;
  width: 30vw;
  height: 2vw;
}
.lil1{
  position: relative;
  margin-bottom: 2vw;
  margin-right: 2vw;
}

.lir1{
  position: relative;
  margin-bottom: 2vw;
  margin-left: 2vw;
}
.lir1:nth-child(4) {
  margin-bottom: 0.1vw;
}

.tactics-top{
  color: #00a0fa;

}
.tacticstopya{
  display: flex;
  flex-direction: row;
  margin-top: 5vw;
}
.circle-container-l1 {
  position: relative;
  width: 10px; /* 根据需要调整宽度 */
  height: 10px; /* 根据需要调整高度 */
   margin-right:2vw; /* 水平居中并添加外边距 */
  justify-content: center;
  align-items: center;
}
.circle-container-r1 {
  position: relative;
  width: 10px; /* 根据需要调整宽度 */
  height: 10px; /* 根据需要调整高度 */
  margin-left: 55px; /* 水平居中并添加外边距 */
  justify-content: center;
  align-items: center;
}
.circle3 {
  background-color: #b2e2fd; /* 第一个圆形的颜色 */
  width: 20px; /* 第一个圆形的宽度 */
  height: 20px; /* 第一个圆形的高度 */
}
.circle4 {
  background-color:  #00a0fa; /* 第二个圆形的颜色 */
  width: 10px; /* 第二个圆形的宽度 */
  height: 10px; /* 第二个圆形的高度 */
}
.l1{
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
}
.r1{
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
}

.container3{
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  justify-content: center;
  text-align: center;
  padding-right: 10%;
  padding-left: 10%;
}
.kong{
  width: 100%;
  height: 20px;
}
.title02 {
  font-family: "Source Han Sans CN";
  color: rgb(26, 26, 26);
  font-weight: bold;
  line-height: 1;
  background: url("@/tu/1x/about/logo.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  height: 140px;
  width: 100%;
  text-align: center;
  justify-content: center;
  align-items: center;
  /*filter: brightness(0) saturate(100%) invert(96%) sepia(0%) saturate(0%) hue-rotate(0deg);*/
}

.title02 h2 {
  text-align: center;
  width: 100%;
  font-size:@logo-fontsize;
  font-family: "Source Han Sans CN";
  color: rgb(26, 26, 26);
  font-weight: @logo-font-weight;
  line-height: @logo-font-line-height;
  padding-top: 38px;

}

.title03 h2 {
  text-align: center;
  height: 140px;
  width: 100%;
  font-size:@logo-fontsize;
  font-family: "Source Han Sans CN";
  color: white;
  font-weight:@logo-font-weight;
  line-height: @logo-font-line-height;
  margin-top: -103px;
  z-index: 500;
  position: relative;

}
.container9{
  position: relative;
  width: 100%;
  height: 700px;

}
.bottomDescription{
  font-size: 54px;
  font-family: "Source Han Sans CN";
  color: rgb(255, 255, 255);
  font-weight: bold;
  line-height: 1.279;
}
/* 移动端样式 */
@media screen and (max-width: 768px) {
  .container9 {

    height: 40vw;

  }
}



.background-image {
  position: absolute;
  width: 100%; /* 使用视口宽度单位，确保与页面宽度一致 */
  height: 100%;
  object-fit: cover; /* 确保图片覆盖整个区域 */
  left: 50%; /* 水平居中 */
  transform: translateX(-50%); /* 水平居中偏移 */
  z-index: -1;
}

.bottomDescription {
  position: relative;
  z-index: 1;
  color: white;
  font-size: 1.2vw;
  text-align: left;
  left:10%;
  padding-top: 5%;
}
.bottomDescription p {
  font-size: 54px;
  font-family: "Source Han Sans CN";
  color: rgb(255, 255, 255);
  font-weight: bold;
  line-height: 1.279;
}




/* 移动端样式 */
@media screen and (max-width: 767px) {
  .bottomDescription p {
    font-size: 20px;

  }
}

/* 超小屏幕样式 */
@media screen and (max-width: 375px) {
  .bottomDescription p {
    font-size: 14px;

  }
}

.controlNext {
  position: absolute;
  top: 80%;
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  max-width: 1920px;
  margin: 0 auto;
  left: 50%;
  transform: translateX(-50%);
  gap: clamp(20px, 3vw, 60px);
}

.last, .next {
  cursor: pointer;
  width: clamp(30px, 4vw, 60px);
  height: clamp(30px, 4vw, 60px);
  transition: all 0.3s ease;
}

/* 移动端样式 */
@media screen and (max-width: 768px) {
  .controlNext {
    top: 80%;
    width: 90%;
    /* padding: 0 15px; */
  }

  .last, .next {
  width: 4vw;
  height: 4vw;
}
}

/* Responsive design */
@media screen and (max-width: 768px) {
  .badges {
    flex-direction: column; /* Stack badges vertically */
    align-items: center; /* Center badges horizontally */
    margin-top: 70px;
  }

  .badge {
    width: 90%; /* Full width for each badge */
    margin: 1vw auto; /* Center badges with auto margins */
    font-size: @phoneText-fontsize;
  }

}

/* Responsive design */
@media screen and (max-width: 768px) {

  .container-1{
    padding: 0;
  }
  .jingzheng{
    padding: 0;
    height: auto;
    min-height: 0 !important;
  }
  .container1 {
    flex-direction: column; /* Stack children vertically */
    align-items: center; /* Center children horizontally */

  }
  @media screen and (max-width: 768px) {
    .container1 {
      padding-bottom: calc(60vw + 500px );
    }

  }
  @media screen and (max-width: 708px) {
    .container1 {
      padding-bottom: calc(65vw + 600px );
    }

  }
  @media screen and (max-width: 650px) {
    .container1 {
      padding-bottom: calc(70vw + 600px );
    }

  }
  @media screen and (max-width: 600px) {
    .container1 {
      padding-bottom: calc(75vw + 600px );
    }

  }
  @media screen and (max-width: 550px) {
    .container1 {
      padding-bottom: calc(80vw + 600px );
    }

  }
  @media screen and (max-width: 520px) {
    .container1 {
      padding-bottom: calc(80vw + 610px );
    }

  }
  @media screen and (max-width: 490px) {
    .container1 {
      padding-bottom: calc(80vw + 660px );
    }

  }
  @media screen and (max-width: 450px) {
    .container1 {
      padding-bottom: calc(90vw + 700px );
    }

  }
  @media screen and (max-width: 400px) {
    .container1 {
      padding-bottom: calc(100vw + 750px );
    }

  }
  @media screen and (max-width: 390px) {
    .container1 {
      padding-bottom: calc(90vw + 750px );
    }

  }
  @media screen and (max-width: 380px) {
    .container1 {
      padding-bottom: calc(90vw + 780px );
    }

  }
  @media screen and (max-width: 370px) {
    .container1 {
      padding-bottom: calc(90vw + 800px );
    }

  }
  @media screen and (max-width: 360px) {
    .container1 {
      padding-bottom: calc(90vw + 800px );
    }

  }







  .content-background {
    position: absolute;
    right: 0;
    top: 0;
    width: 100%; /* 增加背景宽度 */
    /*height: 100%;*/
    /*background-color: #f8f8f8;*/
    z-index: 1;
    margin-right: 0;
    margin-top: 0;
  }
  .image-about {
    position: relative;
    left: 0;
    width: 100%;
    height: auto;
    margin-top: 0;
    object-fit: cover;
    z-index: 2;
    padding-top: 45px;
  }

  .box {
    position: relative;
    width: 100%; /* 增加内容区域宽度 */
    padding: 10px 10px 10px 10px; /* 增加右侧内边距，给文字更多空间 */
    z-index: 2;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    background-color: #f8f8f8;
  }

  .content {

    width: 90%;
    padding: 0;
  }

  .content h1:first-child {
    color: #00a0fa;
    font-size: @phone-fontsize;
    line-height: 1.2;
    margin-bottom: 10px;
    padding-top: 60px;
  }

  .content h1:nth-child(2) {
    color: #00a0fa;
    font-size: @phone-fontsize;
    line-height: 1.2;
    margin-bottom: 20px;
  }

  .content p {
    font-size: @text-fontsize;
    color: #666;
    line-height: 1.8;
    margin-bottom: 15px;
    max-width: 600px; /* 设置文字最大宽度，确保可读性 */
  }


}

/* Responsive design */
@media screen and (max-width: 768px) {
  .stats {
    justify-content: space-around; /* Distribute space evenly */


  }

  .stat {
    width: 50%; /* Approximately half the width of the container */
    text-align: center;
    margin: 10px 15px;
  }

  .stat-box {
    flex-direction: column; /* Stack content vertically within each stat */
    align-items: center; /* Center content horizontally */

  }

  .stat-value-right {
    text-align: center; /* Center text within each stat */
    margin: 1vw 0; /* Adjust margin for spacing */
  }
  .stat-value {
    font-size: @phone-fontsize;
  }

  .stat-about{
    margin-top: 1vw;
    font-size: @phone-stat-about-fontsize;
  }
  .stat-icon {
    color: gray;
  }
  .stat-icon img {
    width: 12vw;
    height: auto;
  }
  .stat-value-el {
    font-size: @phoneText-fontsize;
    font-weight:400;
    color:  #00a0fa;
  }
  .description {
    font-size: 3.5vw;
    margin: 0;
    padding: 0;
    color: gray;
    line-height: 5vw;
  }
  .title02 {
    font-weight:bold;
    margin-top:20px;
    margin-bottom:20px;
    color: black;
    background: url("@/tu/1x/about/logo.png");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    height: 100px;

  }
  .title02 h2{
    font-size:@title-M-fontsize;
    white-space: nowrap;
    padding-top: 25px;
  }

  .title03 h2 {
    text-align: center;
    height: 140px;
    width: 100%;
    font-size:@title-M-fontsize;
    font-family: "Source Han Sans CN";
    color: white;
    margin-top: -95px;
    z-index: 500;
    position: relative;

  }
  .title01 {
    font-size: 4vw;
    font-weight:bold;
    margin-top:2vw;
    margin-bottom:2vw;
    color: black;
    background: url("@/tu/1x/about/logo.png");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    height: 10vw;
    width: auto;
  }
  .description {
    font-size: 3vw;
    margin: 0;
    padding: 0;
    color: gray;
    line-height: 5vw;
  }

}










@media screen and (max-width: 768px) {

.container5{
  width:100%;
  height:600px;
  position: relative;
  text-align: center;

}

.resource-background{
  position: absolute;
  width: 100%;
  height:100%;
  background: url("@/assets/about/About-Map@2x.png");
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-position: 50% 60% ;
  z-index: 10;

}
.resource-description{
  margin-left:2%;
  position: absolute;
  justify-content: left;
  text-align: left;
  width: 100%;
  height: 90%;
  top:10%;
}
.resource-description p{
 /* font-size: 14px;*/
  color:#595757;
  line-height: 1.5;
  margin-bottom: 0.5vw;
  padding: 0;
}
.resource-p{
  font-size: 14px;
  line-height:1.2;
  display: flex;
  flex-direction: row;
  margin: 0;
  padding: 0;
}
.resource-develop{
  position: relative;
  justify-content: left;
  text-align: left;
  width: 100%;
  height: auto;
  top:80%;
  left:1%;
}
.resource-develop p{
 /* font-size: 14px;*/
  color:#595757;
  line-height:2;
  display: flex;
  flex-direction: row;
  margin: 0;
  padding: 0;
}
.resource-dot{
  display: flex;
  margin-left:20px;
  flex-direction: row;
  justify-content: left;
  align-items: center;
}
.resource-key{
  margin-left:5vw;
  display: flex;
  justify-content: left;
  align-items: center;
  position: absolute;
  top:76%;
  left:21%;
}
.resource-key p{
 /* font-size: 14px;*/
  margin-left: 0;
}
}

.container6-new {
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

}

.advance-new {
  width: 100%;
  min-height: 900px;
  max-height: 1080px;
  height: 100vh;
  position: relative;
  background: url("@/assets/about/bottomya.png") no-repeat center;
  background-size: cover;
  margin-top: 30px;
  left: 0;
  right: 0;
}

.bottom-new {
  position: absolute;
  right: 0;
  /* margin-right: 2%; */
  top: 20%;
  left: 55%;
  width: 40%;
  height: auto;
  z-index: 2;
  overflow: hidden;
}

.bottom-new img {
  width: 80%;
  height: auto;
  display: block;
  margin-right: 15%;  /* 减小右边距 */
}

.result-word-new {
  position: absolute;
  left: 2.5%;
  top: 40%;
  width: 75%;
  text-align: left;
  color: white;
  z-index: 3;
}

.result-word-new .result-title {
  display: flex;
  flex-direction: column;
  margin-left: 10%;
  margin-bottom: 0;
  font-size: 33px;
  font-family: "Source Han Sans CN";
  color: rgb(255, 255, 255);
  line-height: 1.351;
  text-align: left;


}

.result-word-new .result-title h1 {
  font-size: @result-title-fontsize;
  font-family: "Source Han Sans CN";
  color: rgb(255, 255, 255);
  line-height: @result-font-line-height;
  text-align: left;
  font-weight: @result-font-weight;
}

.result-word-new .result-title h1 span {
  display: inline;
  font-size: @result-title-fontsize;
  font-family: "Source Han Sans CN";
  color: rgb(255, 255, 255);
  line-height: @result-font-line-height;
  text-align: left;
  font-weight: @result-font-weight;
}

.result-word-new .result-description {
  margin-top: 5%;
  font-size: @result-text-fontsize;
  font-family: "Source Han Sans CN";
  color: rgb(255, 255, 255);
  line-height: @result-font-line-height;
  text-align: Left;
  margin-left: 10%;
  width: 80%;
  font-weight: @result-font-weight;

}

.result-card-new {
  position: absolute;
  bottom: 15%;
  left: 10%;
  width: 80%;
  background: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /*border-radius: 4px;*/
}

.card-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;


}

.card-item:not(:last-child)::after {
  content: '';
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 40px;
  width: 1px;
  background-color: #e0e0e0;
}

.card-item.blue-bg {
  background-color: #00a0fa;
  font-size: @number-fontsize;
  font-family: "Source Han Sans CN";
  color: rgb(255, 255, 255);
  font-weight: 100;
  text-align: left;
}

.card-number {

  font-weight: bold;
  margin-bottom: 2px;
  display: flex;
  align-items: baseline;

}
.card-number.blue-text{
  font-size: 36px;
  font-family: "Source Han Sans CN";
  color: rgb(0, 160, 250);
  font-weight: bold;
  text-align: left;
}
.card-number white-text{
  font-size: 45px;
  font-family: "Source Han Sans CN";
  color: rgb(255, 255, 255);
  font-weight: 100;
  text-align: left;

}
.card-unit {
  font-size:@numberEl-fontsize;
  font-weight: @number-font-weight;
  font-family: "Source Han Sans CN";
  color: rgb(89, 87, 87);
  line-height: 2.389;
  text-align: Left;
  margin-left: 5px;
  }

.card-text {
  font-size:@numberText-fontsize;
  font-weight: @number-font-weight;
  font-family: "Source Han Sans CN";
  color: rgb(89, 87, 87);
}

.blue-text {
  color: #00a0fa;
}

.white-text {
  color: white;

}


@media screen and (max-width: 768px) {
  .advance-new {
    height: auto;
    justify-content: center;
    background-size: cover;
    background-position: center;
    overflow: hidden;
    margin-top: 40px;
    min-height: 1000px;
    max-height:1050px;
  }

  .bottom-new {
    position: relative;
    top: -8%;
    margin: 25px auto;
    width: 80%;
    height: auto;
    z-index: 2;
    left:0;
  }

  .bottom-new img {
    width: 100%;
    height: auto;
    display: block;
    margin-top: 0;
    object-fit: contain;
  }

  .result-word-new {
    position: relative;
    left: 0;
    width: 82.5%;
    text-align: justify;
    color: white;
    z-index: 3;
    top:-7% ;
  }

  .result-word-new .result-title {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    margin-left: 10%;
    width: 100%;
  }


  .result-word-new .result-title h1 {
    font-size: 16px;
    line-height: 1.5;
    font-weight: normal;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: left;
    text-align: left;
  }

  .result-word-new .result-title h1 span {
    display: inline;
    font-size: 16px;
    color: white;
  }

  .result-word-new .result-description {
    width: 100%;
    color: white;
    font-size: 14px;
    line-height: 1.6;
    margin-left: 10%;
  }

  .result-card-new {
    position: relative;
    bottom: 10%;
    left: 10%;
    width: 80%;
    top:-4%;
    background: rgba(255, 255, 255, 0.5);
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 60px 0;

  }
  @media screen and (max-width: 440px)  {
    .result-card-new {
      position: relative;
      bottom: 10%;
      left: 10%;
      width: 80%;
      top:calc(33% + 80px );
      background: rgba(255, 255, 255, 0.5);
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 40px 0;

    }
  }

  .card-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
  }


  .card-item:not(:last-child)::after {
    content: '';
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    height: 40px;
    width: 0;
    background-color: #e0e0e0;
  }

  .card-item.blue-bg {
    padding: 20px 0;
    margin: -20px 0;
  }

  .card-number {
    font-size: @title-M-fontsize;
    font-weight: bold;
    display: flex;
    align-items: baseline;
  }

  .card-unit {
  font-size: 18px;
  font-family: "Source Han Sans CN";
  color:white;
  text-align: Left;

  }
  .card-item.blue-bg{
    background-color:transparent;;
  }
  .card-text {
    font-size: 14px;
    color:white;
  }

  .blue-text {
    color: white;
  }

  .white-text {
    color: white;
  }
  .card-number.blue-text{
  font-size: @title-M-fontsize;
  font-family: "Source Han Sans CN";
  color: rgb(255, 255, 255);
  font-weight: bold;

  text-align: left;

}
.card-number white-text{
  font-size: 36px;
  font-family: "Source Han Sans CN";
  color: rgb(255, 255, 255);
  font-weight: bold;
  line-height: 0.99;
  text-align: left;
  padding-top: 0.5vw;

}

}


.decorative-line {
  width:70px;
  height: 3px;
  background-color: #00a0fa;
  margin: 20px 0;
}

.jingzheng-content {
  display: flex;
  width: 100%;
  max-width: 1400px;
  height: 550px;
  background-image: url('@/assets/about/四大优势.png');
  background-size:80%;
  background-repeat: no-repeat;
  background-position: 100% -100%;
  flex-direction: column;
  align-items: flex-start;
  /*padding: 40px 10% 40px 10%;*/
  position: relative;
  overflow: hidden;
  padding: 80px 0;
}

@media screen and (max-width: 768px) {
  .jingzheng-content {
    height: auto;
    min-height: 600px;
    padding: 30px 5%;
    background-size: 90% auto;
    background-position: 100% 100%;
    margin-bottom: 10%;
  }
}

.jingzheng-description {
  font-size: 27px;
  font-family: "Source Han Sans CN";
  color: rgb(89, 87, 87);
  line-height: 1.593;
  text-align: Left;
  margin-bottom: 40px;
}

.jingzheng-text {
  display: flex;
  flex-direction: row;
  font-size:@jingzheng-text-fontsize;
  font-weight: @jingzheng-font-weight;
  line-height: @jingzheng-font-line-height;
  font-family: "Source Han Sans CN";
  color: rgb(0, 160, 250);
  text-align: left;
}

.jingzheng-subtext {
  font-size:@jingzheng-subtext-fontsize;
  font-weight: @jingzheng-font-weight;
  line-height: @jingzheng-font-line-height;
  font-family: "Source Han Sans CN";
  color: rgb(89, 87, 87);
}



/* 移动端样式 */
@media screen and (max-width: 767px) {
  .jingzheng-content {
    height: auto;
    min-height: 500px;
    padding: 0 5%;
    background-position: center bottom;
    background-size: 90% auto;
    background-position: 50% 90%;
    margin-bottom: 0;
  }

  .jingzheng-description {
    width: 100%;
    margin-bottom: 20px;
  }

  .jingzheng-text {

    margin: 4px 0;
  }

  .jingzheng-subtext {
    font-size: 14px;
    margin: 4px 0;
  }
  .decorative-line {
  width: 50px;
  height: 3px;
  background-color: #00a0fa;
  margin-top: 40px;
}

}

/* 超小屏幕样式 */
@media screen and (max-width: 375px) {
  .jingzheng-content {
    min-height: 480px;
    padding: 20px 10%;
  }

  .jingzheng-text {
    font-size: 16px;
  }

  .jingzheng-subtext {
    font-size: 12px;
  }
}

.ziyuanyoushi {
  width: 100%;
  overflow: hidden;
  /*padding: 0px 10% 60px 10%;*/
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  min-height: 900px;
}

.ziyuanyoushi-content {
  width: 100%;
  max-width: 1400px;
  height:750px;
  background-image: url('@/assets/about/渠道优势/yimi.png');
  background-size: 65%;
  background-repeat: no-repeat;
  background-position:80% 10%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
 /* padding: clamp(30px, 4vw, 60px) clamp(5%, 15%, 10%);*/
  position: relative;
  overflow: hidden;
}

.ziyuanyoushi-text {
  width: clamp(50%, 60%, 70%);

}

.main-text {
  font-size: @main-text-fontsize;
  line-height: @ziyuanyoushi-font-line-height;
  font-weight: @ziyuanyoushi-font-weight;
  font-family: "Source Han Sans CN";
  color: rgb(89, 87, 87);
  margin-bottom: clamp(8px, 1vw, 15px);
  text-align: Left;
}

.divider {
  width:70px;
  height: 3px;
  background-color:#00a0fa;
  margin-top: 25px;
}
@media screen and (max-width: 768px) {
  .divider{
    margin-bottom: 200px;
    margin-top: 40px;
  }
}
.key-progress {
  margin-top: clamp(20px, 3vw, 40px);
}

.key-progress h3 {
  font-size:@key-progress-h3-fontsize;
  font-weight:@ziyuanyoushi-font-weight;
  line-height: @ziyuanyoushi-font-line-height;
  font-family: "Source Han Sans CN";
  color: rgb(89, 87, 87);
  margin-bottom: clamp(15px, 2vw, 30px);
  text-align: Left;
}

.progress-items {
  display: flex;
  flex-direction: column;
  gap: clamp(10px, 1.5vw, 20px);
  padding-bottom: clamp(5%, 8%, 10%);
}

.progress-item {
  display: flex;
  align-items: center;
  gap: clamp(8px, 1vw, 15px);
}

.dot {
  width: clamp(16px, 2vw, 20px);
  height: clamp(16px, 2vw, 20px);
  background-color: #b2e2fd;
  border-radius: 50%;
  position: relative;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.dot::after {
  content: '';
  width: clamp(8px, 1vw, 10px);
  height: clamp(8px, 1vw, 10px);
  background-color: #00a0fa;
  border-radius: 50%;
  position: absolute;
  top: 25%;
  left: 25%;
}

.progress-item p {
  font-weight: @ziyuanyoushi-font-weight;
  font-size: @progress-item-p-fontsize;
  line-height: @ziyuanyoushi-font-line-height;
  font-family: "Source Han Sans CN";
  color: rgb(89, 87, 87);
  text-align: left;
}

@media screen and (max-width: 768px) {
  .container6-new{
    padding: 0;
    margin-top: 0;
  }
  .ziyuanyoushi-content {
    height: auto;
    min-height: 400px;
    padding: 0 5%;
    background-position: center center;
    background-size: 100% auto;
  }
  .ziyuanyoushi{
    min-height:0 !important;;
    margin-top:-100px;
    padding: 0;
    height: 1100px;
  }

  .ziyuanyoushi-text {
    width: 100%;
  }

  .main-text {
    font-size: 16px;
  }

  .key-progress h3 {
    font-size: 16px;
  }

  .progress-item p {
    font-size: 16px;
  }

  .progress-items {
   /* margin-top: 200px;*/
  }

  .dot {
    width: 16px;
    height: 16px;
  }

  .dot::after {
    width: 8px;
    height: 8px;
  }
}

.qudaoyoushi {
  width: 100%;
  height: 100vh;
  min-height:1080px;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.qudaoyoushi-content {
  width: 90%;
  max-width: 1400px;
  height: 780px;
  background-image: url('@/assets/about/渠道优势/未标题-3-02.png');
  background-size:65% auto;
  background-repeat: no-repeat;
  background-position: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
  overflow: visible;
  margin-bottom: 50px;
}

.qudaoyoushi-text {
  width: 80%;
  margin-bottom: 30px;
  position: relative;
  z-index: 2;
  padding:0;

}
@media screen  and (max-width: 768px) {
  .qudaoyoushi{
    margin-top: 150px;
    padding: 20px 0;

  }
}
.channel-text {
  font-size: @channel-title-fontsize;
  font-family: "Source Han Sans CN";
  color: rgb(51, 51, 51);
  font-weight:bolder;
  line-height:@channel-font-line-height;
}

.channel-key {
  font-size: 27px;
  font-family: "Source Han Sans CN";
  color: rgb(89, 87, 87);
  line-height: 1.778;
  text-align: Left;
}

.channel-key h3 {
  font-size: 18px;
  font-family: "Source Han Sans CN";
  color: rgb(89, 87, 87);
  line-height: 1.778;
  text-align: Left;
}

.channel-items {
  margin-top: 15px;
}

.channel-item {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
}

.channel-item .dot {
  position: relative;
  width: 20px;
  height: 20px;
  background-color: #b2e2fd;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.channel-item .dot::after {
  content: '';
  width: 10px;
  height: 10px;
  background-color: #00a0fa;
  border-radius: 50%;
  position: absolute;
  }

.channel-item p {
  font-size: @channel-text-fontsize;
  font-family: "Source Han Sans CN";
  color: rgb(89, 87, 87);
  line-height: @channel-font-line-height;
  line-height: @channel-font-line-height;
}

/* 响应式调整 */
@media screen and (max-width: 768px) {
  .channel-text {
    font-size: 16px;
    font-weight: 400;
  }

  .channel-key h3 {
    font-size: 16px;
  }

  .channel-item .dot {
    width: 16px;
    height: 16px;
  }
  .channel-item{
    font-size: 16px;
    font-weight: 400;
    color: #333;
    line-height: 2;
  }

  .channel-item .dot::after {
    width: 8px;
    height: 8px;
  }

  .channel-item p {
    font-size: 16px;
  }
}




.partners-title {
  font-size: @partners-title-fontsize;
  font-weight: @channel-font-weight;
  line-height: @channel-font-line-height;
  color: #595757;
  font-weight: normal;
}

.partners-image {
  width: 65%;
  height: auto;
  object-fit: contain;
  clip-path: inset(0 1% 0 0); /* 裁剪右侧35%的内容，只保留左侧65% */
  margin-left: -2.2%;
}

/* 响应式调整 */
@media screen and (max-width: 768px) {
  .qudaoyoushi {
    height: auto;
    min-height: 700px;
  }

  .qudaoyoushi-content {
    min-height: 550px;
    height: auto;
    padding: 20px 5%;
    background-position: center 90%;
    background-size: 100% auto;
    margin-bottom: 30px;
  }

  .qudaoyoushi-text {
    width: 100%;
    margin-bottom: 20px;
    padding: 15px 0;


  }

  .channel-partners {
    width: 100%;
    position: absolute;
    top: 85%; /* 使用 top 替代 margin-top */
    left: 6%;
    z-index: 2;
}
  .partners-title {
    font-size: 16px;
    text-align: left;
  }

  .partners-image {
    margin-left: 0;
    max-width: 150%;
    width: 45vw;
    clip-path: inset(0 1% 0 0);
  }
}



.chanpingyoushi {
  width: 100%;
  position: relative;
  overflow: hidden;
}

.chanpingyoushi-content {
  width: 100%;
  position: relative;
}

.chanpingyoush-shangbufen {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 40px;
}

.chanpingyoushi-box {
  width: 100%;
  max-width: 1400px;
  border: 2px solid #cccccc;
  padding: 30px;
  text-align: center;
  border-radius: 20px;
  margin: 60px 0 35px 0;

}

.chanpingyoushi-text1 {
  font-size: @quality-item-title-fontsize;
  font-family: "Source Han Sans CN";
  color: rgb(0, 160, 250);
  font-weight:@text-font-weight;
  line-height: @quality-font-line-height;
}

.chanpingyoushi-text2 {
  font-size: @quality-title-fontsize;
  font-family: "Source Han Sans CN";
  color: rgb(153, 153, 153);
  line-height:@quality-font-line-height;
  font-weight: @quality-font-weight;
}

/* 响应式样式 */
@media screen and (max-width: 768px) {
  .chanpingyoushi{
    padding: 0;
  }
  .chanpingyoushi-box {
    width: 90%;
    padding: 20px;
  }

  .chanpingyoushi-text1 {
    font-size: 16px;
  }

  .chanpingyoushi-text2 {
    font-size: 14px;
  }
}



.chanpingyoushi-xiabufen {
  width: 95%;
  margin: 0 auto;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  top:-10%;
  margin-left: 5%;
  margin-top: calc(-5%  + 6px );
}


.chanpingyoushi-item {
  width: 361px;
  height: 361px;
  margin: 10px;
  padding: 20px;
  background-image: url('@/assets/about/quality.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  transition: all 0.3s ease;
}

.item-title-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  text-align: center;
  position: absolute;
  top: -10%;

}

.chanpingyoushi-item:nth-child(even) {
  margin-left: -4%;
}

.chanpingyoushi-item:nth-child(odd) {
  margin-left: -4%;
}

.item-title {
  width: 180px;
  height: 50px;
  border: 2px solid #00a0fa;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
  background-color: #00a0fa;
  position: relative;
  z-index: 3;
  font-size:@quality-item-titleA-fontsize;
  font-family: "Source Han Sans CN";
  color: rgb(255, 255, 255);
  line-height: @quality-font-line-height;
  font-weight: @quality-font-weight;
}

.item-description {
  width: 80%;
  color: rgb(153, 153, 153);
  font-size: @quality-text-fontsize;
  font-family: "Source Han Sans CN";
  line-height: @quality-font-line-height;
  font-weight: @quality-font-weight;
  text-align: left;
  position: relative;
  z-index: 3;
  padding: 10px 25px;
  border-radius: 8px;
  height: 100px;
}

/* 响应式样式 */
@media screen and (max-width: 768px) {
  .chanpingyoushi-xiabufen {
    width: 100%;
    flex-direction: column;
    align-items: center;
    padding: 20px 0;
  }

  .chanpingyoushi-item {
    width: 240px;
    height: 240px;
    margin: 10px 0;
  }
  .item-title-box{
    top:0;
  }
  .item-description{
    width :80%;
    font-size: 14px;
    color: rgb(153, 153, 153);
  }
  .item-title{
    width: 120px;
    height: 35px;
    top:0;
    font-size: 18px;
  }

  .chanpingyoushi-item:nth-child(even),
  .chanpingyoushi-item:nth-child(odd) {
    width: 280px;
    height: 280px;
    margin-top: 10px;
    margin-bottom: 10px;
  }
}



.date-display {
  position: absolute;
  top:15%;
  right: 10%;
  color: white;
  font-family: "Source Han Sans CN", sans-serif;
  z-index: 10;
}

.date-number {
  font-size: 42px;
  font-family: "Source Han Sans CN";
  color: rgb(255, 255, 255);
  font-weight: bold;
  line-height: 1.47;
}

.date-separator {
  font-size: 24px;
  margin: 0 2px;
}

.total-days {
  font-size: 32px;
  font-family: "Source Han Sans CN";
  color: rgb(242, 242, 242);
  line-height: 3.351;
}

@media screen and (max-width: 768px) {

  .date-display {
    top: 20px;
    right: 30px;
  }

  .date-number {
    font-size: 24px;
  }

  .date-separator, .total-days {
    font-size: 16px;
  }
  .bottomDescription{
    padding-top:25%;
  }

}

@media screen and (min-width: 769px) and (max-width: 1800px) {

  .container1 {
    width: 90%;

    padding: 0;
    margin: 0 auto;
  }
  .content{
    padding-left: 50px;
  }


  .content-background {
    height: calc(100% + 120px);
  }

  .image-about {
    width: 68%;
    height: 100%;
    object-position: 80% 0;
  }

  .box {
    width: 180%;
  }

  .content {
   /* position: absolute;*/
    left: 0;
    top: 5%;
    width: 90%;
  }
/*
  .content h1:first-child,
  .content h1:nth-child(2) {
    font-size: calc(24px + 1vw);
    line-height: 1.4;
    margin-bottom: 15px;
  }

  .content p {
    font-size: calc(14px + 0.5vw);
    line-height: 1.6;
    margin-bottom: 15px;
  }
*/
  .advance-new {
    height: calc(5vw + 700px) ;
    background-size: cover;
    background-position: center;
    margin-top: 10px;
  }

  .bottom-new {
   /* width: 35%;
    top: 5%;
    right: 5%;*/
  }

  .bottom-new img {
    width: 100%;
    margin-right: 0;
  }

  .result-word-new {
   /* left: 5%;
    top: 25%;
    width: 70%;*/
  }

  .result-word-new .result-title h1 {
    margin-bottom: 10px;
  }

  .result-word-new .result-description {
    margin-top: 1%;
    width: 100%;
    text-align: justify;
  }

  .result-card-new {
    bottom: 14%;
    width: 80%;
    left: 12.5%;
  }

  .card-item {
    height: 80px;

  }

  @media screen and (max-width: 1440px) {
  .advance-new {
    height:35vw;
  }

  .result-card-new {
    bottom: 4%;
  }
}

  @media screen and (max-width: 1300px) {
    .advance-new {
      height:37vw;
    }

    .result-card-new {
      bottom: 4%;

    }
    .result-word-new .result-description {
      width: 116%;
      text-align: justify;
    }
  }
@media screen and (max-width: 1100px) {
  .advance-new {
    height:50vw;
  }
  .result-word-new{
   top:28%
  }
  .result-card-new {
       bottom: 4%;
     }
}
@media screen and (max-width: 1000px) {
  .advance-new {
    height:55vw;
  }

  .result-card-new {
    bottom: 8%;
  }
}
@media screen and (max-width: 990px) {
  .advance-new {
    height:63vw;
  }

  .result-card-new {
    bottom: 4%;
  }
}
@media screen and (max-width: 880px) {
  .advance-new {
    height:68vw;
  }

  .result-card-new {
    bottom: 4%;
  }
}
  .card-number.blue-text,
  .card-number.white-text {

    padding-top: 0;
  }

  .ziyuanyoushi{
    margin-top: 0;
  }
  .jingzheng-content {
    height:39vw ;
    padding: 10px 10%;
    background-size: 80% auto;
    background-position: 100% 0;

  }
  @media screen and (max-width: 1440px) {
    .jingzheng-content {
      height: 39vw;
    }
    .jingzheng-content {
      height:39vw ;
      padding: 0 10%;
      background-size: 80% auto;
      background-position: 100% 20%;
    }
  }
  @media screen and (max-width: 1200px) {
  .jingzheng-content {
    height: 65vw;
  }
    .jingzheng-content {
      height:65vw ;
      padding: 10px 15%;
      background-size: 100% auto;
      background-position: 100% 50%;
    }
  }
  @media screen and (max-width: 1100px) {
    .jingzheng-content {
      height: 75vw;
    }
    .jingzheng-content {
      height:75vw ;
      padding: 10px 15%;
      background-size: 100% auto;
      background-position: 100% 60%;
    }
  }
  @media screen and (max-width: 1000px){
    .jingzheng-content {
      height: 85vw;
      .jingzheng-content {
        height:85vw ;
        padding: 10px 15%;
        background-size: 100% auto;
        background-position: 100% 70%;
      }
    }
  }
  @media screen and (max-width: 900px){
    .jingzheng-content {
      height: 95vw;
    }
    .jingzheng-content {
      height:95vw ;
      padding: 10px 15%;
      background-size: 100% auto;
      background-position: 100% 80%;
    }
  }
  @media screen and (max-width: 800px){
    .jingzheng-content {
      height: 105vw;
    }
    .jingzheng-content {
      height:39vw ;
      padding: 10px 15%;
      background-size: 100% auto;
      background-position: 100% 90%;
    }
  }

  .jingzheng-text {
  /*  font-size: calc(20px + 0.8vw);*/
    line-height: 1.5;
    margin-bottom: 15px;
  }

  .jingzheng-subtext {
 /*   font-size: calc(14px + 0.4vw);*/
    line-height: 1.6;
  }

  .ziyuanyoushi-content {
    height: calc(15vw + 300px);
    padding: 10px 10%;
    background-size: 55% auto;
    background-position: 80% 0;
  }

  @media screen and (max-width: 1200px) {
    .ziyuanyoushi-content {
      height: 55vw;
      background-position: 90% 30%;
      background-size: 70% auto;
    }
  }
  @media screen and (max-width: 1100px) {
    .ziyuanyoushi-content {
      height: 57vw;
      background-position: 90% 20%;
      background-size: 80% auto;
    }
  }

  .main-text {
   /* font-size: calc(14px + 0.4vw);*/
    line-height: 1.8;
    margin-bottom: 10px;
  }

  .key-progress h3 {
  /*  font-size: calc(16px + 0.4vw);*/
    margin-bottom: 15px;
  }



  .qudaoyoushi-content {
    height: 780px;
    background-size: 70% auto;
    background-position: 90% 71%;
    padding: 10px 5%;
  }
  .qudaoyoushi-text{
    padding: 0;
  }
  @media screen and (max-width: 1440px) {
    .qudaoyoushi-content {
      height: 37vw;
      background-position: 100% 95%;
    }
    .channel-partners{
      position: absolute;
      top: 70%;
      left:13%;
    }

  }
  @media screen and (max-width: 1200px) {
    .qudaoyoushi-content {
      height: 55vw;
      background-position: 100% 95%;
    }
    .channel-partners{
      position: absolute;
      top: 80%;
      left:13%;
    }

  }

  .channel-text {
    /*font-size: calc(24px + 1vw);*/
    line-height: 1.4;
    margin-bottom: 20px;
  }

  .channel-key h3 {
    /*font-size: calc(16px + 0.4vw);*/
    margin-bottom: 15px;
  }

  .channel-item p {
   /* font-size: calc(14px + 0.3vw);*/
    line-height: 1.6;
  }
  .chanpingyoushi-xiabufen {
    margin-top: calc(-5%  - 20px);
  }
  @media screen and (max-width: 1200px){
    .chanpingyoushi-xiabufen {
      margin-top: calc(-6%  - 20px);
    }
  }

  .chanpingyoushi-box {
    width: 85%;
    padding: 40px 20px;
  }

  .chanpingyoushi-text1 {
   /* font-size: calc(20px + 0.8vw);*/
    margin-bottom: 15px;
  }

  .chanpingyoushi-text2 {
   /* font-size: calc(14px + 0.4vw);*/
    line-height: 1.8;
  }

  .chanpingyoushi-item {
    width: calc(250px + 1vw);
    height: calc(250px + 1vw);
    margin: 15px;
  }

  .item-title {
    width: calc(120px + 2vw);
   /* font-size: calc(16px + 0.4vw);*/
  }

  .item-description {
   /* font-size: calc(12px + 0.3vw);*/
    line-height: 1.6;
    width: 70%;
    color: rgb(153, 153, 153);
    padding:0;
  }
}
@media screen and (max-width: 768px) {
  .CaiDanBottom{
    height:100px;
    width: 100%;
  }
  .chanpingyoushi-item:nth-child(odd){
    left:0;
  }
  .chanpingyoushi-item:nth-child(even){
    left:0;
  }

}
@media screen and (max-width: 1200px) {
  .chanpingyoushi-item {
    width: calc(260px + 0.1vw);
    height: calc(260px + 0.1vw);
    margin: 15px;
  }

  .item-title {
    width: calc(100px + 2vw);
  }
}
@media screen and (max-width: 1077px) {
  .chanpingyoushi-item {
    width: calc(360px + 0.1vw);
    height: calc(360px + 0.1vw);
    margin: 15px;
  }

  .item-title {
    width: calc(140px + 2vw);
  }
}

</style>
